import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ChangeDetectorRef, Component, computed, DestroyRef, ElementRef, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, NgForm } from '@angular/forms';
import { Params } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CalendarMonthViewDay } from 'angular-calendar';
import moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { APPOINTMENT_CONSTANT } from '../../../constants/appointment-constants';
import { DATE_ISO_FORMAT, DATE_TIME_ISO_FORMAT, DATE_TIME_ISO_T_FORMAT, TIME_FORMAT } from '../../../constants/date.constants';
import { TEMPLATE_CONSTANT } from '../../../constants/template.constant';
import { TRANSLATION_TEMPLATES } from '../../../constants/translation-templates-constants';
import { APPOINTMENT_SOURCE_ID, BOOKING_CUSTOM_FIELD_TYPES, BOOKING_REDIRECTION_VIEWS, CAPTCHA_TYPE, GTM_EVENTS, LOCAL_STORAGE_CONSTANTS, PARENT_TO_CHILD_IFRAME_EVENT_ACTIONS, PARENT_TO_CHILD_IFRAME_EVENTS, PARENT_TO_CHILD_IFRAME_VALIDATION_CONTROL_NAME, PAYMENT_TYPES, WIDGET_CONSTANTS, WIDGET_DISPLAY_TIMEZONE_SOURCE, WINDOW_LISTENER_CONSTANTS } from '../../../constants/widget-constants';
import { CustomerDbModel, CustomFieldsDao } from '../../../db-models/appointment-custom-fields-dao';
import { AppointmentReservationBody } from '../../../db-models/appointment-reservation.model';
import { AppointmentServiceDao, MappedAppointmentServicesDao } from '../../../db-models/appointment-service-dao';
import { CalendarHighlightModel } from '../../../db-models/calendar-highlight.model';
import { CouponDbModel } from '../../../db-models/coupon-db.model';
import { AppointmentsSlotsDao, DayWiseFreeSlotsDao } from '../../../db-models/free-appointment-dao';
import { PayPalOrderDetailModel, PayPalSettingsDbModel } from '../../../db-models/partner-setting.model';
import { StoresDao } from '../../../db-models/stores-dao';
import { TimezoneDbModel } from '../../../db-models/timezone.model';
import { UserDao } from '../../../db-models/user-data-dao';
import { WidgetAppointmentGroupModel } from '../../../db-models/widget-appointment-group.dao';
import { AppointmentAnalyticsDao, CustomBookingMessageTemplate, WidgetBookingInfoDao, WorkerDao } from '../../../db-models/widget-conf-dao';
import { AppointmentServiceCategoryModel } from '../../../models/appointment-service-category';
import { AppointmentBookItem, CartItem } from '../../../models/cart.model';
import { GlobalObjects, Partner } from '../../../models/global';
import { AdyenPaymentDetails } from '../../../models/adyen.model';
import { AdyenResumeFailure, AdyenResumeReturn, AdyenResumeSnapshot } from '../../../models/adyen-resume.model';
import { AdyenResumeService } from '../../../services/adyen-resume.service';
import { buildAdyenHoldScope } from '../../../services/adyen-booking-context.util';
import { canBookAfterAdyenPayment, isCaptchaChallengePending, reservationExpiredMessageKey } from '../../../services/adyen-payment-booking.util';
import { SaferPayPaymentDetailsDbModel } from '../../../models/saferpay.model';
import { AppointmentState, ConferenceState, UserState } from '../../../models/state.model';
import { WidgetColorConf } from '../../../models/widget-color.model';
import { CustomerPrefillDataModel } from '../../../models/widget-conf';
import { AppointmentCartService } from '../../../services/appointment-cart.service';
import { AppointmentService } from '../../../services/appointment.service';
import { CalendarHighlightService } from '../../../services/calendar-highlight.service';
import { CaptchaService } from '../../../services/captcha.service';
import { CustomEventService } from '../../../services/custom-event.service';
import { CustomFieldService } from '../../../services/custom-field.service';
import { DateUtilsService } from '../../../services/date-utils.service';
import { FormsService } from '../../../services/forms.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { HelperService } from '../../../services/helper.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { LoggerService } from '../../../services/logger.service';
import { PartnerService } from '../../../services/partner.service';
import { PaymentService } from '../../../services/payment.service';
import { workerServesStore } from '../../../services/store-scope.util';
import { TimezoneService } from '../../../services/timezone.service';
import { UtilService } from '../../../services/util.service';
import { calculateVat, isVatAddedOnTop, VatResult } from '../../../services/vat-calculation.util';
import { WidgetUtilService } from '../../../services/widget-util.service';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { FinalpageComponent } from '../../../shared/components/finalpage/finalpage.component';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { MatIconComponent } from '../../../shared/components/mat-icon/mat-icon.component';
import { NewAlertComponent } from '../../../shared/components/new-alert/new-alert.component';
import { AddressFormatPipe } from '../../../shared/pipes/address-format.pipe';
import { CalioMeetingTemplatePipe } from '../../../shared/pipes/calio-meeting-template.pipe';
import { ReplaceQuestionmarkFromEndOfStringPipe } from '../../../shared/pipes/replace-questionmark-from-end-of-string.pipe';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';
import { TrustHtmlPipe } from '../../../shared/pipes/trust-html.pipe';
import { CalendarPickerComponent } from '../../common/calendar-picker/calendar-picker.component';
import { CwPaymentMethodsComponent } from '../../common/cw-payment-methods/cw-payment-methods.component';
import { PersonalDataFormComponent } from '../../common/personal-data-form/personal-data-form.component';
import { QualificationQuestionComponent } from '../../common/qualification-question/qualification-question.component';
import { ReservationCountdownComponent } from '../../common/reservation-countdown/reservation-countdown.component';
import { CwCardHeaderComponent } from '../../common/theme/cw-card-header/cw-card-header.component';
import { CwNewCardComponent } from '../../common/theme/cw-new-card/cw-new-card.component';
import { AppointmentCardComponent } from './appointment-card/appointment-card.component';
import { AppointmentCartOverviewComponent } from './appointment-cart-overview/appointment-cart-overview.component';
import { AppointmentCustomerProfilesComponent } from './appointment-customer-profiles/appointment-customer-profiles.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { AppointmentMeetingTypeComponent } from './appointment-meeting-type/appointment-meeting-type.component';
import { AppointmentNavigationBarComponent } from './appointment-navigation-bar/appointment-navigation-bar.component';
import { AppointmentWorkerCardComponent } from './appointment-worker-card/appointment-worker-card.component';
import { CrossSellingServicesComponent } from './cross-selling-services/cross-selling-services.component';
import { getDomRoot } from '../../../services/dom-root.util';
import { resolvePersonalFormZip } from '../../../services/store-postcode.util';
import {
  adyenErrorMessageKey,
  isAlreadyBookedWithPayment,
  isBookingOutcomeUnknown,
  isPaidBookingStillCompleting,
  isPaymentSessionSpent,
  REFUND_NOTICE_KEY,
  refundNoticeKeyFor,
} from '../../../services/booking-outcome.util';
import { isInvoiceAddressMandatoryFor } from '../../../services/invoice-address.util';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
  imports: [
    NgClass, NgTemplateOutlet, FormsModule, TranslateModule, NgSelectModule,
    QualificationQuestionComponent, FinalpageComponent, ButtonComponent, LoaderComponent, AlertComponent,
    AppointmentNavigationBarComponent, NewAlertComponent, AppointmentCustomerProfilesComponent, AppointmentListComponent,
    AppointmentWorkerCardComponent, CalendarPickerComponent, AppointmentCardComponent, CwNewCardComponent,
    CwCardHeaderComponent, PersonalDataFormComponent, CwPaymentMethodsComponent, AppointmentCartOverviewComponent,
    MatIconComponent, CrossSellingServicesComponent, AppointmentMeetingTypeComponent, ReservationCountdownComponent,
    DatePipe, TranslationPipe, TrustHtmlPipe, CalioMeetingTemplatePipe, ReplaceQuestionmarkFromEndOfStringPipe, AddressFormatPipe
  ]
})
export class AppointmentComponent implements OnInit, OnDestroy {

  @Input() partner: Partner;
  @Input() globals: GlobalObjects;
  @Input() isClicked: boolean;
  @Input() lang: string;
  @Input() isFrame: boolean;
  @Input() widgetBookingInfo: WidgetBookingInfoDao;
  @Input() widgetColorConf: WidgetColorConf;
  @Input() widgetConf: any;
  @Input() selectedStoreId: number;
  // number | undefined: these are normalised through toOptionalNumber(), and an absent value
  // must stay absent rather than becoming NaN. Declaring the union makes any site that assumes
  // a value a compile-visible smell.
  @Input() selectedStoreZipCode: number | undefined;
  @Input() selectedStoreName: string;
  @Input() selectedWorkerId: number | undefined;
  @Input() selectedWorkerIds: number[];
  @Input() selectedAppointmentServiceIds: string[];
  @Input() selectedAppointmentServiceCategoryIds: string[];
  @Input() selectedJsonCustomFields: {
    [key: number]: { type: string; value: any } | any;
  };
  @Input() selectedJsonCustomerDetail: CustomerPrefillDataModel;
  @Input() calendarPreselectedDate: string;
  @Input() dateContext: string;
  @Input() dateContextStart: string;
  @Input() dateContextEnd: string;
  @Input() bookerWorkerId: number | undefined;
  @Input() utmSource: string;
  @Input() utmMedium: string;
  @Input() utmCampaign: string;
  @Input() utmContent: string;
  @Input() utmTerm: string;
  @Input() utmId: string;
  @Input() meeting_type_id: string;
  @Input() customer_notification_preference: string;
  @Input() isBookingDisabled = false;
  @Input() foundedWorker: WorkerDao;
  @Input() internalComment: string;
  @Input() langSwitcher = true;
  @Input() conferenceState: ConferenceState;
  @Input() hideStoreSelection = false;
  @Input() skipQualificationQuestion = false
  @Input() bookingType: string;
  @Input() customer: CustomerDbModel;
  @Input() widgetTemplates: CustomBookingMessageTemplate[] = [];
  @Input() timezones = new Array<TimezoneDbModel>();
  @Input() preApplyCoupon: string;
  @Input() redirectedPaymentIntent: string;
  @Input() redirectedPaymentIntentClientSecret: string;
  @Input() appointmentStripeRedirectionData: Record<string, any>;
  /** An Adyen payment this tab parked before leaving the page, now back (see AdyenResumeService). */
  @Input() adyenResume?: AdyenResumeReturn;
  @Input() customerProfileUuid: string;
  @Input() selectedJsonBrokerDetail: CustomerPrefillDataModel;
  @Input() enteredAppointmentFromTour = false;
  @Input() prefetchedTourCombiService: AppointmentServiceDao | null = null;

  @Output() bookingSuccessEvent: EventEmitter<any> = new EventEmitter<any>();
  // resetSelection = true when triggered after a successful booking ("book another appointment")
  // so the tour factory page starts fresh. False when triggered by user clicking back from DATE,
  // so the previous tour selection is preserved.
  @Output() backToTourEvent: EventEmitter<{ resetSelection: boolean }> = new EventEmitter<{ resetSelection: boolean }>();

  @ViewChild('appointmentsSection') appointmentsSectionRef: ElementRef;
  @ViewChild('appointmentForm') appointmentForm: NgForm;

  private appointmentService = inject(AppointmentService);
  private calendarHighlightService = inject(CalendarHighlightService);
  private captchaService = inject(CaptchaService);
  private cartService = inject(AppointmentCartService);
  private cdr = inject(ChangeDetectorRef);
  private customEventService = inject(CustomEventService);
  private customFieldService = inject(CustomFieldService);
  private dateUtilsService = inject(DateUtilsService);
  private destroyRef = inject(DestroyRef);
  private deviceDetectorService = inject(DeviceDetectorService);
  private elementRef = inject(ElementRef);
  private formService = inject(FormsService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private helperService = inject(HelperService);
  private localStorageService = inject(LocalStorageService);
  private partnerService = inject(PartnerService);
  private paymentService = inject(PaymentService);
  /** Book waits while the payment form is down behind a "check your email first" notice. */
  protected readonly payAgainRequired = this.paymentService.payAgainRequired;
  private timezoneService = inject(TimezoneService);
  private translateService = inject(TranslateService);
  private adyenResumeService = inject(AdyenResumeService);
  /** What cw-adyen parks before an Adyen payment leaves the page: the Stripe redirect snapshot. */
  protected readonly adyenResumeSnapshot = (): AdyenResumeSnapshot => ({
    host: 'appointment',
    data: this.buildRedirectionSnapshot(),
  });
  private utilService = inject(UtilService);
  private widgetUtilService = inject(WidgetUtilService);

  protected isWhitelabel(): boolean {
    return this.partnerService.hasFeature('is_whitelabel_enabled');
  }

  protected readonly parentToChildIframeEventActions = PARENT_TO_CHILD_IFRAME_EVENT_ACTIONS;
  protected readonly parentToChildIframeEvents = PARENT_TO_CHILD_IFRAME_EVENTS;
  protected readonly parentToChildIframeValidationControlName = PARENT_TO_CHILD_IFRAME_VALIDATION_CONTROL_NAME;
  protected readonly dateIsoFormat = DATE_ISO_FORMAT;
  protected readonly dateTimeIsoFormat = DATE_TIME_ISO_FORMAT;
  protected readonly templateContent = TRANSLATION_TEMPLATES;
  protected readonly appointmentConstant = APPOINTMENT_CONSTANT;
  protected readonly widgetConstant = WIDGET_CONSTANTS;
  protected readonly environment = environment;
  protected readonly bookingCustomFieldTypes = BOOKING_CUSTOM_FIELD_TYPES;
  protected readonly paymentTypes = PAYMENT_TYPES;

  protected get timeFormat(): string {
    return this.dateUtilsService.userTimeFormat.moment;
  }

  // When partner has opted into 'partner' mode, slot-fetch & booking payloads carry the partner's
  // configured timezone regardless of visitor's browser TZ. Falls back to visitor TZ otherwise.
  private get effectiveDisplayTimezone(): string {
    if (this.partner?.widget_display_timezone_source === WIDGET_DISPLAY_TIMEZONE_SOURCE.PARTNER && this.partner?.timezone) {
      return this.partner.timezone;
    }
    return this.userState?.timezone ?? this.timezoneService.localTimezone;
  }
  protected readonly svgIcons = [
    { name: 'person-f', path: 'assets/images/material/person_fillded.svg' },
    { name: 'event-f', path: 'assets/images/material/event_filled.svg' },
    { name: 'edit', path: 'assets/images/material/edit.svg' },
    { name: 'plus-f', path: 'assets/images/material/plus-square-filled.svg' },
  ];
  protected readonly slotGhostElementsCount = new Array<number>(4);
  protected readonly bookingRedirectionViews = BOOKING_REDIRECTION_VIEWS;
  protected readonly templateConstant = TEMPLATE_CONSTANT;

  protected viewMode = WIDGET_CONSTANTS.APPOINTMENT;
  cartLength: number;
  customerSelected: object = null;
  stores: StoresDao[] = [];
  keepWorkerId = 0;
  isMobile: boolean;
  disableBookingButton = false;
  stripeElementLoading = false;
  isReservationExpired = false;
  booked = false; // Call final page with message if true
  duration: number;
  formReseted = false; // Do we show message that form is reset
  appointmentServicesAvailable: AppointmentServiceDao[];
  appointmentServicesByCat = Array<AppointmentServiceCategoryModel>();
  isServicesLoading = false;
  workerAvatarUrl = environment.workerAvatarUrl;
  baseUrl = environment.baseUrl;
  workersIdsPerService = new Map<number, number[]>();
  allWorkerObjects = new Map<number, UserDao>();
  workersAvailable = Array<UserDao>();
  workersAvailableWithAnyoneOption = Array<UserDao>();
  calendarLoaded = false;
  viewDate: Date;
  old_select_calendar: CalendarMonthViewDay = null;
  disablePrev = true;
  days = Array<CalendarMonthViewDay>();
  now: Date;
  monthChanged = false;
  lastCalendarMonth: number;
  freeAppointments = Array<{
    dayPeriod: string;
    appointments: AppointmentsSlotsDao[];
    showDayPeriodLabel?: boolean;
    widgetGroup: WidgetAppointmentGroupModel;
  }>();
  freeAppointmentsCount = 0;
  lastSelectedAppointment: AppointmentsSlotsDao;
  showAds = false;
  cart: CartItem[] = [];
  noServices = false;
  noWorkers = false;
  noAppointments = false;
  appointmentCustomFields = Array<CustomFieldsDao>();
  addonsCustomFields = Array<CustomFieldsDao>();
  tempArray = Array<CustomFieldsDao>();
  customFieldValues: {
    [key: number]:
    | {
      type: string;
      value: any;
      option_values: {
        custom_field_option_id: number;
        custom_field_option_value: string;
      }[];
    }
    | any;
  } = {};
  qualificationQuestionsValues: {
    [key: number]:
    | {
      type: string;
      value: any;
      option_values: {
        custom_field_option_id: number;
        custom_field_option_value: string;
      }[];
    }
    | any;
  } = {};
  finalPage: boolean;
  finalPageError: string;
  showEgal: boolean;
  totalCartDuration = 0;
  totalCartPrice = 0;
  customFieldsAddonsPrice = 0;
  courtesyForm: string;
  leadTime: number;
  successMessage: string;
  errorMessage: string;
  priceAfterCouponReduction: number;
  /** VAT on top of the discounted net (`plus`/`exclude` partners only) — recalculated on every coupon/cart change. */
  cartVat = signal<VatResult>({ byRate: [], totalCents: 0 });
  successFullBookings: {
    landingPageLink: string;
    bookingUUID: string;
    selectedStore: StoresDao;
  }[] = [];
  CUSTOMFIELDS_LS_NAME: string;
  QUALIFICATIONQUESTION_LS_NAME: string;
  appointmentState: AppointmentState = {
    customerProfileId: null,
    store: null,
    categories: [],
    services: [],
    relatedServices: [],
    worker: null,
    date: null,
    termins: null,
    day: null,
    default_worker_id: null,
    leadGeneratorPostcode: null,
    default_worker: null,
    isCombiServiceSelected: false
  };
  userState: UserState = {
    title: null,
    forename: null,
    lastName: null,
    gender: null,
    eMail: null,
    phone: null,
    mobile: null,
    birthday: null,
    comment: null,
    customerId: null,
    customerUuid: null,
    street: null,
    zip: null,
    city: null,
    country_id: null,
    country: null,
    customer_notification_preference: null,
    meeting_type_id: null,
    company: null,
    internal_comment: null,
    timezone: null
  };
  brokerState: UserState = {
    title: null,
    forename: null,
    lastName: null,
    gender: null,
    eMail: null,
    phone: null,
    mobile: null,
    comment: null,
    customerId: null,
    customerUuid: null,
    street: null,
    zip: null,
    city: null,
    country_id: null,
    country: null,
    customer_notification_preference: null,
    meeting_type_id: null,
    company: null,
    internal_comment: null,
  };
  isServicesTabDisabled = false;
  paypalSetting: PayPalSettingsDbModel;
  stripePaymentMethodId: string;
  showRefundNotice = false;
  refundNoticeKey = REFUND_NOTICE_KEY;
  refundTransactionId: string;
  storageComplete = false;
  calendarSlotsCountList = Array<{ date: Date; slotsCount: number }>();
  coupon: CouponDbModel;
  finalCouponDiscount = 0;
  disableDatePagePreviousButton = false;
  paymentType: string;
  couponDisableConfirmButton = false;
  bookingErrorMessage: string | string[];
  selectedStoreAvailable = false;
  isStripeEnabled = false;
  isServiceOnlinePaymentEnabled = 0;
  isOnlinePaymentMandatory = false;
  isBexioEnabled = false;
  isExternalInvoiceEnabled = false;
  isStoreEnabled = false;
  isLexOfficePaymentTypeEnabled = false;
  isPaypalEnabled = false;
  isSaferpayEnabled = false;
  invoiceAddressChecked = false;
  invoiceAddressValid = true;
  invoiceAddress: AppointmentBookItem['invoice_address'] = undefined;
  isAdyenEnabled = false;
  adyenPaymentDetails: AdyenPaymentDetails;
  @ViewChild(CwPaymentMethodsComponent) private paymentMethodsComponent?: CwPaymentMethodsComponent;
  /**
   * Set when Book validated the form and then asked Adyen to charge the card. The booking
   * resumes in onAdyenPaid() once Adyen authorises, so the shopper presses one button, not two.
   */
  private bookOnceAdyenPaid = false;
  /**
   * An authorisation Adyen accepted and has not answered yet. Book stays enabled while the card
   * is merely INCOMPLETE - nothing was submitted, no callback is coming, and freezing there left
   * a dead button - but once a real payment is in flight a second press would call
   * `dropin.submit()` again, and a 3DS2 challenge keeps that window open for tens of seconds.
   * Cleared by both outcomes: onAdyenPaid() on success, onAdyenReset() on refusal / cancel /
   * SDK error, so the SDK failing to answer at all cannot strand the button.
   *
   * It also locks the booking while the payment runs (the hosted window is open, or Drop-in is
   * authorising): Back, the step bar, Book, the cart and the personal data. The payment's own
   * "Cancel payment" is the one way out, and it releases this through onAdyenReset().
   */
  protected readonly adyenPaymentInFlight = signal(false);
  /** A /book request has been sent and not answered yet (including its booking-lock resends). */
  private bookingRequestInFlight = false;
  nextButtonTemplate: CustomBookingMessageTemplate;
  previousButtonTemplate: CustomBookingMessageTemplate;
  bookButtonTemplate: CustomBookingMessageTemplate;
  dateLabelTemplate: CustomBookingMessageTemplate;
  noBookableDatesTemplate: CustomBookingMessageTemplate;
  yesSearchButtonTemplate: CustomBookingMessageTemplate;
  manageAppointmentNowTemplate: CustomBookingMessageTemplate;
  successTitleTemplate: CustomBookingMessageTemplate;
  downloadBookingDetailTemplate: CustomBookingMessageTemplate;
  selectDayInCalendarMsgTemplate: CustomBookingMessageTemplate;
  widgetAnyoneLabelTemplate: CustomBookingMessageTemplate;
  widgetAnyoneDescTemplate: CustomBookingMessageTemplate;
  summaryPagePersonalInfoHeading: CustomBookingMessageTemplate;
  summaryPageCartDetailsHeading: CustomBookingMessageTemplate;
  summaryPageCrossServiceHeading: CustomBookingMessageTemplate;
  addCrossServiceToCartButtonText: CustomBookingMessageTemplate;
  widgetCalendarHighlightsNoticeText: CustomBookingMessageTemplate;
  redirectionButtonTemplate: CustomBookingMessageTemplate;
  protected bookingIncompleteNoteOnSummaryStep: CustomBookingMessageTemplate;
  protected dateStepErrorTemplate: CustomBookingMessageTemplate;
  protected readonly showDateStepValidationError = signal(false);
  // Nothing is bookable at all (e.g. the preselected worker has bookable = 0), so the whole
  // wizard is replaced by a single message instead of rendering empty steps.
  protected readonly bookingUnavailable = signal(false);
  // A booking request failed for a non-business reason (network, 5xx) — retrying may help,
  // so this gets "please reload" copy rather than the not-bookable copy.
  protected readonly bookingLoadFailed = signal(false);
  // Whether a services load has actually completed. Needed because viewMode is APPOINTMENT
  // from construction while the list is still empty and isServicesLoading is still false —
  // without it the empty-state message flashes on every load.
  protected readonly servicesResolved = signal(false);
  // Whether the stores lookup has completed (either way). Without it the "nothing to book" state
  // cannot be told apart from "the stores request has not come back yet", and the message would
  // flash on every load.
  protected readonly storesResolved = signal(false);
  // The services request itself failed (5xx / network). Distinct from "loaded and empty", so a
  // transient outage is not reported to the visitor as "this provider cannot be booked".
  protected readonly servicesLoadFailed = signal(false);
  // There is nothing for the visitor to do in the wizard — render the explanation instead of it.
  protected readonly bookingBlocked = computed(() => this.bookingUnavailable() || this.bookingLoadFailed());
  showBookableDateNotAvailableIssue = false;
  automaticBookableDateProcessIsEnabled = false;
  automationBookingDatesLimitReached = false;
  selectedWorker: UserDao;
  hideResourceStep = false;
  protected hideMeetingTypesStep = false;
  widgetGroups = Array<WidgetAppointmentGroupModel>();
  childCustomFieldsLoadedSubscription: Subscription;
  removeCustomFieldsSubscription: Subscription;
  /**
   * 0 ==> don't show anything
   * 1 ==> show ghost element
   * 2 ==> show appointments
   * */
  showAppointmentSlotGhostElement = 0;
  appointmentSlotGhostElements: number[] = [1, 2, 3, 4, 5, 6];
  paypalOrderDetail: PayPalOrderDetailModel;
  saferPayPaymentDetails: SaferPayPaymentDetailsDbModel;
  isPaymentInProgress = false;
  isInvalidCoupon = false;
  hideBookingButton = false;
  isCustomFieldsLoaded = false;
  private STATE_LS_NAME;
  private CART_LS_NAME;
  USER_LS_NAME;
  CALENDAR_SLOTS_COUNT_LS_NAME;
  isUserMadeFirstInteraction = false;
  showFullscreenOverlay = false;
  calendarDate = false;
  backButtonClicked = false;
  hardCodedSelectedAppointmentServiceIds: string[];
  hardCodedSelectedAppointmentServiceCategoryIds: string[];
  qualificationQuestions = Array<CustomFieldsDao>();
  hasQualificationQuestions = false;
  hasQualificationQuestionsAnswered = false;
  availableSlotsArray = Array<AppointmentsSlotsDao>();
  showAppointmentSlots = false;
  getDaysWiseFreeSlots$: any;
  showWorkersListOnDateStep = false;
  summaryDetails: Params;
  showSummaryDetails = false;
  protected troubleshootingModeEnabled = false;
  protected crossSellingServices = Array<AppointmentServiceCategoryModel>();
  protected bookButtonLoader = false;
  protected slotAlreadyReservedByOtherError = false;
  protected reservingAppointment = false;
  protected calendarHighlightData = Array<CalendarHighlightModel>();
  protected showWidgetCalendarOverwriteNotice = Array<CalendarHighlightModel>();
  protected exceptionWorkers = new Array<string>();
  protected debugCommonNotes = new Array<string>();
  protected stripeConnectedAccountId: string;
  protected defaultPaymentType = '';
  protected showStripeRedirectionLoader = false;

  constructor() {
    this.translateService.onLangChange.subscribe(language => {
      this.lang = language.lang;
      this.createSuccessMessage(language.lang);
      this.createErrorMessage();
    });

    this.helperService.registerSvgIconsList(this.svgIcons);
  }

  private setupDates(): void {
    const timezone = this.userState.timezone || this.timezoneService.getLocalTimezone();
    this.now = new Date(moment.tz(timezone).format(DATE_TIME_ISO_T_FORMAT));
    const defaultViewDate = new Date(moment.tz(timezone).format(DATE_TIME_ISO_T_FORMAT));

    if (this.dateContext && this.dateContextStart && this.dateContextEnd) {
      const startDateContextMoment = moment(this.dateContext, this.dateIsoFormat).tz(timezone).subtract(this.dateContextStart, 'days');
      const endDateContextMoment = moment(this.dateContext, this.dateIsoFormat).tz(timezone).add(this.dateContextEnd, 'days');

      const isInPast = startDateContextMoment.isBefore(moment().tz(timezone));
      const isInFuture = endDateContextMoment.isSameOrAfter(moment().tz(timezone));

      this.viewDate = isInPast && isInFuture ? defaultViewDate : new Date(moment(this.dateContext).startOf('month').format(DATE_TIME_ISO_T_FORMAT));
    } else {
      this.viewDate = defaultViewDate;
    }

    this.lastCalendarMonth = this.viewDate.getMonth() + 1;
    this.updateCalendarPrevState(this.viewDate);
  }

  ngOnInit() {
    if (this.redirectedPaymentIntent && this.redirectedPaymentIntentClientSecret && this.appointmentStripeRedirectionData) {
      // Handle redirect from Stripe payment verification
      LoggerService.log('[Local Storage] Redirected from Stripe payment verification');

      // Set payment type to CREDITCARD
      this.paymentType = this.paymentTypes.CREDITCARD;

      // Set stripe payment method ID from redirected payment intent
      this.stripePaymentMethodId = this.redirectedPaymentIntent;

      // Set loading states
      this.disableBookingButton = true;
      this.bookButtonLoader = true;
      this.bookingErrorMessage = undefined;

      if (this.appointmentStripeRedirectionData) {
        this.showStripeRedirectionLoader = true;
        LoggerService.log('[Local Storage] Found stored bookingItems, proceeding with booking');

        // Update stripe_payment_intent_id with the redirected payment intent ID
        this.appointmentStripeRedirectionData.bookingItems.forEach(item => {
          if (item.payment_type === this.paymentTypes.CREDITCARD) {
            item.stripe_payment_intent_id = this.redirectedPaymentIntent;
          }
        });

        // Proceed with booking directly
        this.processBooking(this.appointmentStripeRedirectionData.bookingItems);
        this.restoreRedirectionSnapshot(this.appointmentStripeRedirectionData);
      } else {
        LoggerService.error('[Local Storage] Redirected payment intent exists but stored bookingItems are missing');
        this.bookingErrorMessage = 'Something is wrong with session store data. Please try again.';
        this.disableBookingButton = false;
        this.bookButtonLoader = false;
      }
    } else if (this.adyenResume) {
      this.resumeAdyenPayment(this.adyenResume);
    }
    this.setupDates();

    // Check for qualification questions (skip if redirected from Stripe payment or entering from tour flow —
    // tour users chose services via the tour UI, qualification routing doesn't apply)
    if (
      !(this.redirectedPaymentIntent && this.redirectedPaymentIntentClientSecret && this.appointmentStripeRedirectionData) &&
      !this.adyenResume &&
      !this.enteredAppointmentFromTour
    ) {
      this.hasPartnerQualificationQuestions();
    }

    // Keeping backup of selectedAppointmentServiceIds to use it while pre-selecting appointment service on store change
    this.hardCodedSelectedAppointmentServiceIds = this.selectedAppointmentServiceIds;
    this.hardCodedSelectedAppointmentServiceCategoryIds = this.selectedAppointmentServiceCategoryIds;

    // Widget attributes arrive as strings and a web-component consumer may pass an empty one, so
    // anything that is not a real number has to become undefined. These three previously read
    // selectedWorkerId to decide all three assignments, and fell back to Number(), which turns an
    // absent value into NaN rather than undefined.
    this.selectedWorkerId = this.toOptionalNumber(this.selectedWorkerId);
    this.selectedStoreZipCode = this.toOptionalNumber(this.selectedStoreZipCode);
    this.bookerWorkerId = this.toOptionalNumber(this.bookerWorkerId);

    this.isMobile = this.deviceDetectorService.isMobile();

    // Set local storage name for form state
    this.setLocalstorageNames();
    this.initFormState();
    this.showEgal = this.partner.showEgalWer;

    if (this.widgetUtilService.getWidgetConf().subscriptionTypeId === 1) {
      this.showAds = true;
    }
    this.courtesyForm = this.widgetUtilService.getWidgetConf().courtesyForm;
    this.leadTime = this.widgetUtilService.getWidgetConf().appointmentLeadTime;

    // Set initial templates
    this.setupInitialTemplates();
    this.createSuccessMessage(this.lang);
    this.createErrorMessage();

    this.customEventService.hideBookingButtonEvent.subscribe(result => this.hideBookingButton = result.hide);

    if (this.partner?.is_customer_profiles_feature_enabled !== 1) {
      this.fetchAvailableStores();
    } else {
      if (this.partner?.customer_profiles?.length === 1) {
        this.appointmentState.customerProfileId = this.partner?.customer_profiles[0].id;
        this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT);
      } else {
        this.viewMode = APPOINTMENT_CONSTANT.CUSTOMER_TYPE;
      }
    }

    this.childCustomFieldsLoadedSubscription = this.customEventService.childCustomFieldsLoadedEvent.subscribe(
      result => this.tempArray = this.tempArray.concat(result)
    );

    this.removeCustomFieldsSubscription = this.customEventService.removeChildCustomFieldsEvent.subscribe(ids => {
      this.tempArray = this.tempArray.filter(item => ids.indexOf(item.id) === -1);
    });

    this.listenFromParentIFrame();

    this.partnerService.hasFeature('is_widget_highlight_enabled') && this.getAllCalendarHighlights();

    this.customFieldService.addonsCustomFieldsPriceEvent.subscribe(() => {
      this.localStorageService.getItem(this.CUSTOMFIELDS_LS_NAME, (savedCustomFieldsState) => {
        if (savedCustomFieldsState) {
          this.customFieldsAddonsPrice = Object.values(savedCustomFieldsState as Record<string, { price?: number | number[] }>)
            .reduce((sum, item) =>
              sum + (item?.price
                ? Array.isArray(item.price)
                  ? item.price.reduce((a, b) => a + b, 0)
                  : item.price
                : 0),
              0);
          this.cartService.addonsCustomFieldsPrice = Number(this.customFieldsAddonsPrice);
          this.cartService.recalculateCart(this.cart);
          this.totalCartPrice = this.cartService.totalCartPrice;
          this.calculateCoupon();
          this.customEventService.addonsPriceChangeEvent.emit(this.customFieldsAddonsPrice);
        }
      });
    });
  }

  private hasPartnerQualificationQuestions(): void {
    this.formService.getPartnerQualificationQuestions().subscribe({
      next: (questions) => {
        if (questions?.length) {
          this.qualificationQuestions = this.prefillCustomFields(questions, true);
          this.qualificationQuestionsValues = structuredClone(this.customFieldValues)
          LoggerService.log('[Qualification questions] Yes, partner has qualification questions');
          this.hasQualificationQuestions = true;

          if (this.skipQualificationQuestion) {
            this.hasQualificationQuestionsAnswered = true;
            this.submitQualificationQuestions(true);
          } else {
            this.hasQualificationQuestionsAnswered = false;
          }
        } else {
          this.qualificationQuestions = [];
          this.hasQualificationQuestions = false;
          this.hasQualificationQuestionsAnswered = false;
        }
      },
      error: (error: HttpErrorResponse) => LoggerService.error(error)
    });
  }

  listenFromParentIFrame(): void {
    window.addEventListener('message', (event: any) => {
      if (document.referrer) {
        const referrer = new URL(document.referrer);
        if (
          [`${referrer.protocol}//${referrer.hostname}`, referrer.origin].includes(event.origin)
        ) {
          if (
            event.data?.action &&
            event.data?.eventName &&
            event.data.eventName === this.parentToChildIframeEvents.NAVIGATION
          ) {
            LoggerService.log('[message received from parent to child for navigation]', event?.data);
            this.handleParentToChildNavigation(event);
          }
        } else {
          LoggerService.warn('[Receiving message from non-whitelisted origin]', event.origin, referrer.origin);
        }
      }
    });
  }

  handleParentToChildNavigation(event: any): void {
    if (Object.values(this.parentToChildIframeEventActions).includes(event.data.action)) {
      switch (this.viewMode) {
        case this.appointmentConstant.DATE:
          if (event.data.action === this.parentToChildIframeEventActions.PREVIOUS && !this.disableDatePagePreviousButton) {
            this.backButtonClicked = true;
            this.navigateTo(this.appointmentConstant.WORKER);
          } else if (event.data.action === this.parentToChildIframeEventActions.NEXT) {
            if (this.cart.length > 0) {
              this.navigateTo(this.appointmentConstant.PERSONAL_INFO);
            } else if (this.appointmentState.date === null) {
              this.widgetUtilService.sendMessageToParent({
                eventName: this.parentToChildIframeEvents.VALIDATION,
                controls: [this.parentToChildIframeValidationControlName.DATE, this.parentToChildIframeValidationControlName.SLOT]
              });
            } else if (this.cart === null || this.cart?.length === 0) {
              this.widgetUtilService.sendMessageToParent({
                eventName: this.parentToChildIframeEvents.VALIDATION,
                controls: [this.parentToChildIframeValidationControlName.SLOT]
              });
            }
          }
          break;
        case this.appointmentConstant.PERSONAL_INFO:
          if (event.data.action === this.parentToChildIframeEventActions.PREVIOUS) {
            this.navigateTo(this.appointmentConstant.DATE);
          } else if (
            event.data.action === this.parentToChildIframeEventActions.BOOK
          ) {
            if (!this.isValidBooking()) {
              this.widgetUtilService.sendMessageToParent({
                eventName: this.parentToChildIframeEvents.VALIDATION,
                controls: [this.parentToChildIframeValidationControlName.PERSONAL_FORM]
              });
            } else if (!this.hideBookingButton) {
              if (this.paymentType === this.paymentTypes.SAFERPAY) {
                this.payUsingSaferpay();
              } else if (this.paymentType === this.paymentTypes.CREDITCARD) {
                this.payUsingStripe();
              } else {
                this.book();
              }
            }
          }
          break;
        default:
          this.customEventService.iFrameNavigationFromParent.emit(event.data.action);
          break;
      }
    }
  }

  setupInitialTemplates(): void {
    this.nextButtonTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_NEXT
    );
    this.previousButtonTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_PREVIOUS
    );
    this.bookButtonTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_BOOK_BUTTON
    );
    this.dateLabelTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_DATE_LABEL
    );
    this.noBookableDatesTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_NO_BOOKABLE_DATES_LABEL
    );
    this.yesSearchButtonTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_YES_SEARCH_BUTTON_LABEL
    );
    this.manageAppointmentNowTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_MANAGE_BOOKING_LABEL
    );
    this.downloadBookingDetailTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_DOWNLOAD_APPOINTMENT_ICS_FILE
    );
    this.selectDayInCalendarMsgTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_CHOOSE_DATE_HINT
    );
    this.widgetAnyoneLabelTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_ANYONE_LABEL
    );
    this.widgetAnyoneDescTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_ANYONE_DESC_LABEL
    );
    this.summaryPagePersonalInfoHeading = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.SUMMARY_PAGE_PERSONAL_INFO_HEADING
    );
    this.summaryPageCartDetailsHeading = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.SUMMARY_PAGE_CART_DETAILS_HEADING
    );
    this.summaryPageCrossServiceHeading = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_SUMMARY_STEP_CROSS_SERVICES_SECTION_HEADING
    );
    this.addCrossServiceToCartButtonText = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_SUMMARY_STEP_ADD_CROSS_SERVICE_BUTTON_TEXT
    );
    this.widgetCalendarHighlightsNoticeText = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_CALENDAR_HIGHLIGHTS_NOTICE
    );
    this.redirectionButtonTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.REDIRECTION_BUTTON_TEMPLATE
    );
    this.bookingIncompleteNoteOnSummaryStep = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.BOOKING_INCOMPLETE_NOTE_ON_SUMMARY_STEP
    );
    this.dateStepErrorTemplate = this.helperService.findTemplate(
      this.widgetTemplates, WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_STEP_ERROR_DATE
    );
  }

  createSuccessMessage(lang: string): void {
    const appointmentBookingInfoTemplate = this.widgetTemplates?.find(template => template.identifier === WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_BOOKING_INFO_APPOINTMENT);
    appointmentBookingInfoTemplate && (appointmentBookingInfoTemplate.is_multi_language = 1);
    this.successMessage = this.utilService.getBookingInfoMessage(appointmentBookingInfoTemplate, lang);

    const translateConstant = (this.courtesyForm === 'Du' ? 'appointments.finalpage.successMessageDu' : 'appointments.finalpage.successMessageSie');

    if (!this.successMessage) {
      this.translateService.get(translateConstant, { leadTime: this.leadTime }).subscribe(res => {
        this.successMessage = res;
        this.customEventService.finalSuccessMessageChangedEvent.emit(this.successMessage);
      });
    } else {
      this.customEventService.finalSuccessMessageChangedEvent.emit(this.successMessage);
    }
  }

  createErrorMessage(): void {
    if (this.courtesyForm === 'Du') {
      this.errorMessage = this.translateService.instant('appointments.finalpage.errorMessageDu')
    } else {
      this.errorMessage = this.translateService.instant('appointments.finalpage.errorMessageSie')
    }
  }

  ngOnDestroy() {
    // unsubscribe from all subscriptions
    if (this.childCustomFieldsLoadedSubscription) {
      this.childCustomFieldsLoadedSubscription.unsubscribe();
    }
    if (this.removeCustomFieldsSubscription) {
      this.removeCustomFieldsSubscription.unsubscribe();
    }
  }

  // Set local storage name for form state
  setLocalstorageNames(): void {
    this.STATE_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_STATE_LS + this.partner.bookingName;
    this.CART_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_CART_LS + this.partner.bookingName;
    this.USER_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_GLOBAL_USER_LS + this.partner.bookingName;
    this.CUSTOMFIELDS_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_CUSTOMFIELDS_LS_NAME + this.partner.bookingName;
    this.QUALIFICATIONQUESTION_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_QUALIFICATIONQUESTION_LS_NAME + this.partner.bookingName;
    this.CALENDAR_SLOTS_COUNT_LS_NAME = APPOINTMENT_CONSTANT.APPOINTMENT_CALENDAR_SLOTS_COUNT_LS_NAME + this.partner.bookingName;
  }

  // Fetch available stores
  fetchAvailableStores(): void {
    this.resetBookingAvailabilityState();

    if (!this.appointmentState.store) {
      if (this.selectedStoreId) {
        this.appointmentState.store = this.selectedStoreId;
      }
    }

    if (
      ((this.partner.enable_store_postcode_feature === 1 && this.widgetConf?.show_stores_as_dropdown === 1) ||
        this.partner.automatic_store_zip_search === 1) &&
      !this.appointmentState.store &&
      ((this.globals?.isInternal && this.partner?.internal_widget_store_search_list === 1) || !this.globals?.isInternal) &&
      !this.enteredAppointmentFromTour
    ) {
      this.stores = [];
      this.appointmentServicesByCat = [];
    } else {
      let appointmentServiceId: number[];
      if (
        this.selectedAppointmentServiceIds &&
        this.selectedAppointmentServiceIds.length === 1
      ) {
        appointmentServiceId = [Number(this.selectedAppointmentServiceIds[0])];
      } else if (
        this.selectedAppointmentServiceIds &&
        this.selectedAppointmentServiceIds.length > 1
      ) {
        appointmentServiceId = this.selectedAppointmentServiceIds.map(id => Number(id));
      }

      const storeParams: {
        appointment_service_ids: number[],
        worker_id?: number,
        worker_ids?: number[],
        category_ids?: number[],
        selected_store_id?: number
      } = {
        appointment_service_ids: appointmentServiceId,
      };

      // Coerced at the point of use, not just at init: selectedWorkerId is an @Input whose runtime
      // value comes from a widget attribute, so it can be a string, and Angular may re-set it after
      // ngOnInit normalised it.
      const selectedWorkerId = this.toOptionalNumber(this.selectedWorkerId);

      if (this.isWorkerSubsetActive()) {
        // Subset mode returns the union of the subset workers' stores.
        storeParams.worker_ids = this.selectedWorkerIds;
      } else if (selectedWorkerId !== undefined) {
        storeParams.worker_id = selectedWorkerId;
      }

      if (this.selectedAppointmentServiceCategoryIds?.length) {
        storeParams.category_ids = this.selectedAppointmentServiceCategoryIds.map(id => Number(id));
      }

      // The store named by the link must come back even when it is only accessible through a
      // deeplink, otherwise setupStoreSelection() cannot preselect it.
      const selectedStoreId = this.toOptionalNumber(this.selectedStoreId);
      if (selectedStoreId !== undefined) {
        storeParams.selected_store_id = selectedStoreId;
      }

      this.formService.getStores(storeParams)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: stores => {
            if (stores?.length) {
              if (!this.globals.isInternal) {
                this.stores = stores.filter(store => store.has_only_internal_appointment_service === 0);
              } else {
                this.stores = stores;
              }
            } else {
              this.stores = [];
              if (this.isWorkerScopedLookup(storeParams)) {
                // A worker-scoped lookup that comes back with no store means this person cannot
                // be booked (e.g. no service is assigned to them). Same dead end as an outright
                // rejection, so it gets the same customer-facing message.
                this.bookingUnavailable.set(true);
              }
            }
            this.storesResolved.set(true);
            this.setupStoreSelection(this.stores);
          },
          error: (err: HttpErrorResponse) => this.handleStoresLoadError(err, storeParams)
        });
    }
  }

  /**
   * Turns a failed stores lookup into a state the template can render.
   *
   * Without this the rejection was only logged, so the widget kept an empty store list, never
   * ran setupStoreSelection() and rendered an empty booking step with no explanation.
   *
   * stores_with_workers rejects a worker-scoped lookup with 400 (the worker has bookable = 0 or
   * is gone, none of the subset workers are bookable, or the subset feature is not in the plan)
   * or 403 (the internal embed may not view that store). Both are permanent for this visitor, so
   * they get the "cannot be booked" message; telling them to try again would be a lie. Anything
   * else (5xx, network) is transient and does get the retry message.
   */
  private handleStoresLoadError(err: HttpErrorResponse, storeParams: { worker_id?: number, worker_ids?: number[] }): void {
    LoggerService.error(err.message);
    // Never leave the services skeleton spinning — no services load will follow this failure.
    this.servicesResolved.set(true);
    this.storesResolved.set(true);

    const isPermanentRejection = err.status === 400 || err.status === 403;
    if (this.isWorkerScopedLookup(storeParams) && isPermanentRejection) {
      this.bookingUnavailable.set(true);
    } else {
      this.bookingLoadFailed.set(true);
    }
  }

  /**
   * Normalise an attribute-supplied number: anything that is not a real, finite number becomes
   * undefined.
   *
   * `Number(undefined)` is `NaN`, and `NaN !== undefined` is true — so an absent value used to
   * survive presence checks and reach the backend as `null` once JSON-serialised. Returning
   * undefined keeps "absent" absent all the way to the wire.
   */
  private toOptionalNumber(value: unknown): number | undefined {
    const raw = value === undefined || value === null ? '' : String(value).trim();
    // Entity ids and postcodes are non-negative integers written in plain decimal, and the
    // digits-only test is what actually enforces that: Number() on its own would turn `true` into
    // 1, `'0x10'` into 16 and `'1e3'` into 1000 — silently resolving nonsense input to a real id.
    // `'0'` still passes, because 0 is the "anyone" sentinel rather than a missing value.
    if (!/^\d+$/.test(raw)) {
      return undefined;
    }
    return Number(raw);
  }

  /**
   * True only when a REAL worker id was sent with the lookup.
   *
   * An absent worker id now normalises to undefined rather than NaN, so a plain presence check
   * would already be correct — this stays an explicit finite-and-positive test because the value
   * originates from a widget attribute and because 0 is the "anyone" sentinel, not a worker. Get
   * this wrong and a legitimately empty store list is reported as "this person cannot be booked",
   * hiding the whole wizard.
   */
  private isWorkerScopedLookup(storeParams: { worker_id?: number, worker_ids?: number[] }): boolean {
    return (Number.isFinite(storeParams.worker_id) && storeParams.worker_id > 0)
      || storeParams.worker_ids?.length > 0;
  }

  private resetBookingAvailabilityState(): void {
    this.bookingUnavailable.set(false);
    this.bookingLoadFailed.set(false);
    this.servicesResolved.set(false);
    this.servicesLoadFailed.set(false);
    this.storesResolved.set(false);
  }

  setupStoreSelection(stores: StoresDao[]): void {
    if (!this.stores.find(store => store.id === this.appointmentState.store)) {
      this.appointmentState.store = null;
    }

    if (this.selectedStoreId) {
      const selectedStore = stores.find(store => Number(store.id) === Number(this.selectedStoreId));

      if (selectedStore) {
        this.selectedStoreAvailable = true;
        this.appointmentState.store = selectedStore.id;

        // When single store is mapped with multiple postcodes or cities when user navigates back
        // it preselects wrong store (technically store id is valid but city name is wrong) so keeping
        // post code mapping id for valid reference (Fix for EGK)
        // appointmentState.store
        this.appointmentState.selectedStorePostcodeMappingId = selectedStore?.postcode_sore_id ?? `${selectedStore.id}`;
        LoggerService.log(
          `CALENSO_BOOKING_WIDGET_INFO_2: Setting store to ${selectedStore.id} because store was preselected using ID.`
        );
      } else {
        LoggerService.warn(
          'CALENSO_BOOKING_WIDGET_ERROR_2: Selected store ID cannot be found in the list of stores. Ignoring the selected store ID.'
        );
        this.selectedStoreAvailable = false;
      }
    } else if (this.selectedStoreZipCode) {
      const zipStore: StoresDao = stores.find((store: StoresDao) => {
        return String(store.zip ?? '').trim().toUpperCase().replace(/\s+/g, '') === String(this.selectedStoreZipCode ?? '').trim().toUpperCase().replace(/\s+/g, '');
      });
      if (zipStore) {
        this.selectedStoreAvailable = true;
        this.selectedStoreId = zipStore.id;
        this.appointmentState.store = zipStore.id;
        LoggerService.log(`CALENSO_BOOKING_WIDGET_INFO_2: Setting store to ${zipStore.id} because store was preselected using store zip.`);
      } else {
        LoggerService.warn('CALENSO_BOOKING_WIDGET_ERROR_2: Selected store ZIP cannot be found in the list of stores. Ignoring the selected store ZIP.');
        this.selectedStoreAvailable = false;
      }
    } else if (this.selectedStoreName) {
      let selectedStore = stores.find(store => {
        if (store.name && this.selectedStoreName) {

          if (store.name.toLowerCase() === this.selectedStoreName.toLowerCase()) {
            return true;
          }

          if (store.is_multi_language === 1) {
            this.widgetConstant.LANGUAGES.forEach(language => {
              if (store?._translations[language.locale].name?.toLowerCase() === this.selectedStoreName.toLowerCase()) {
                return true;
              }
            });
            return false;
          }
        }
        return false;
      });

      if (this.foundedWorker && selectedStore) {
        // Mirror the id-based deep-link guard: only reset when the worker does not serve the
        // named store at all, so a multi-store worker keeps a validly-served secondary store.
        if (!workerServesStore(this.foundedWorker, Number(selectedStore.id))) {
          LoggerService.warn('CALENSO_BOOKING_WIDGET_INFO_1: Selected store name and Worker store id is not matching. Resetting store id to worker store id.'
          );
          selectedStore = stores.find((store: StoresDao) => {
            return Number(store.id) === Number(this.foundedWorker.store_id);
          });
        }
      }

      if (selectedStore) {
        this.selectedStoreAvailable = true;
        this.selectedStoreId = selectedStore.id;
        this.appointmentState.store = selectedStore.id;
        LoggerService.log(`CALENSO_BOOKING_WIDGET_INFO_2: Setting store to ${selectedStore.id} because store was preselected using store name.`);
      } else {
        LoggerService.warn('CALENSO_BOOKING_WIDGET_ERROR_2: Selected store Name cannot be found in the list of stores. Ignoring the selected store Name.');
        this.selectedStoreAvailable = false;
      }
    } else {
      this.selectedStoreAvailable = false;
    }

    // Set selected to first element if not set by local storage
    if (this.appointmentState.store == null) {
      if (
        this.partner.enable_store_postcode_feature !== 1 ||
        (this.partner.enable_store_postcode_feature === 1 && !this.globals.isInternal)
      ) {
        const conditionBlock3 = (
          stores?.length > 1 &&
          (this.globals?.isInternal && this.partner?.internal_widget_store_search_list === 1)
        ) || (
            stores?.length > 1 &&
            !this.globals?.isInternal &&
            this.partner?.enable_store_postcode_feature !== 1 &&
            this.partner?.automatic_store_zip_search !== 1 &&
            this.widgetConf?.show_stores_as_dropdown === 1
          );

        if (
          !conditionBlock3 &&
          this.partner.enable_store_postcode_feature !== 1
        ) {
          this.appointmentState.store = stores?.[0]?.['id'];
        }

        // Non-optional stores[0] threw here whenever the lookup legitimately returned no store,
        // aborting the rest of setupStoreSelection(). It also claimed a store had been set even
        // when the guard above skipped the assignment.
        LoggerService.log(
          `CALENSO_BOOKING_WIDGET_INFO_3: store is not preselected yet; resolved store is ${this.appointmentState.store ?? 'none'}.`
        );
      }

      // Tour flow: store selection UI is skipped — pick a store from the combi's workers
      // (fallback to first store) so setAppointmentServices can proceed.
      if (this.enteredAppointmentFromTour && this.appointmentState.store == null && stores?.length) {
        const combiWorkerStoreId = this.prefetchedTourCombiService?.services_workers?.[0]?.worker?.store_id;
        const matchedStore = combiWorkerStoreId && stores.find(s => s.id === combiWorkerStoreId);
        this.appointmentState.store = matchedStore ? combiWorkerStoreId : stores[0].id;
        LoggerService.log(`[tour] auto-picked store ${this.appointmentState.store} for tour flow`);
      }

      LoggerService.log(`CALENSO_BOOKING_WIDGET_INFO_4: this.appointmentState.store `, this.appointmentState.store);
    }

    if (this.appointmentState.store) {
      this.onStoreSelected(this.appointmentState.store);
    } else {
      if (!this.hasQualificationQuestions) {
        this.appointmentServicesByCat = [];
        this.appointmentState.services = [];
      }
    }
  }

  // Tour widget books a single combi at a time — fully remove each cart item via the
  // standard removeFromCart flow so reservations get released, totals/coupons recompute,
  // calendar badges decrement, and cartItemsChangeEvent fires for any listeners.
  private clearCartForTourBack(): void {
    this.cart.forEach(cartItem => this.removeFromCart(cartItem.cartItemId));
  }

  bookAppointmentAgain() {
    // Tour flow: instead of restarting the appointment flow, route the user back to the tour
    // factory page so they can pick a (potentially new) combo. resetSelection=true clears
    // the previous tour selection so the user starts fresh after a successful booking.
    if (this.enteredAppointmentFromTour) {
      LoggerService.log('[tour] book-again from tour booking, returning to tour factory');
      this.clearCartForTourBack();
      this.backToTourEvent.emit({ resetSelection: true });
      return;
    }

    this.hasPartnerQualificationQuestions();
    this.appointmentService.gtmStartTriggered = false;
    this.bookingErrorMessage = undefined;
    this.successFullBookings = [];
    this.initFormState();

    // Reset payment-related flags for new booking
    this.storageComplete = false;
    this.showRefundNotice = false;
    this.refundTransactionId = undefined;
    this.stripePaymentMethodId = undefined;
    this.paymentType = undefined;
    this.paypalOrderDetail = undefined;
    this.saferPayPaymentDetails = undefined;
    this.adyenPaymentDetails = undefined;
    this.isPaymentInProgress = false;
    this.coupon = undefined;
    this.finalCouponDiscount = 0;
    this.priceAfterCouponReduction = undefined;
    this.cartVat.set({ byRate: [], totalCents: 0 });
    this.isInvalidCoupon = false;
    this.totalCartPrice = 0;

    if (this.stores.length) {
      this.setupStoreSelection(this.stores);
    } else {
      this.fetchAvailableStores();
    }
    if (this.partner.is_customer_profiles_feature_enabled === 1) {
      if (this.partner?.customer_profiles?.length === 1) {
        this.appointmentState.customerProfileId =
          this.partner?.customer_profiles[0].id;
        this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT);
      } else {
        this.viewMode = APPOINTMENT_CONSTANT.CUSTOMER_TYPE;
      }
    } else {
      this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT);
    }
  }

  onStoreSelected(store_id: number): void {
    // Switching store re-runs the whole lookup — clear any stale unavailable/failed state so a
    // good store is never judged by the previous store's result.
    this.resetBookingAvailabilityState();
    this.appointmentServicesByCat = [];
    if (
      this.appointmentState?.services?.length > 0 &&
      (this.partner.enable_store_postcode_feature === 1 ||
        this.partner.automatic_store_zip_search === 1) &&
      ((this.globals?.isInternal &&
        this.partner?.internal_widget_store_search_list === 1) ||
        !this.globals?.isInternal)
    ) {
      // Don't reset appointment state services
    } else {
      if (!this.hasQualificationQuestions) {
        this.appointmentState.services = [];
      }
    }

    this.allWorkerObjects = new Map<number, UserDao>();
    this.getWidgetAppointmentGroups(store_id);
    this.setAppointmentServices();

    if (Number(this.partner.is_round_robin_feature_enabled) === 1) {
      LoggerService.warn('[Debug] Hiding resource step because of is_round_robin_feature_enabled setting');
      this.hideResourceStep = true;
    } else if (
      Number(this.partner.widget_hide_resource_step_for_default_workers) === 1 &&
      this.appointmentState.default_worker_id
    ) {
      LoggerService.warn('[Debug] Hiding resource step because of widget_hide_resource_step_for_default_workers setting');
      this.hideResourceStep = true;
    } else if (Number(this.partner.is_widget_postcode_worker_random_selection_enabled) === 1) {
      LoggerService.warn('[Debug] Hiding resource step because of is_widget_postcode_worker_random_selection_enabled setting');
      this.hideResourceStep = true;
    } else {
      this.hideResourceStep = false;
    }
  }

  resetSelectedAppointmentServiceIds(): void {
    this.selectedAppointmentServiceIds = this.hardCodedSelectedAppointmentServiceIds;
  }

  resetSelectedAppointmentServiceCategoryIds(): void {
    this.selectedAppointmentServiceCategoryIds = this.hardCodedSelectedAppointmentServiceCategoryIds;
  }

  // Set appointment services based on store ID
  setAppointmentServices(): void {
    this.noServices = false;
    this.noWorkers = false;

    if (!this.appointmentState.store) {
      return;
    }

    // Tour flow: /prepare already returned the full combi service DAO with services_workers
    // and category. Skip the redundant HTTP call and process the combi directly. The combi is
    // flagged is_internal=1 by design (hidden from regular listings) — the user explicitly chose
    // it via the tour UI, so bypass the internal-service filter for this path.
    if (this.enteredAppointmentFromTour && this.prefetchedTourCombiService) {
      LoggerService.log('[tour] skipping /appointment_services/by_store — using prefetched combi service');
      this.isServicesLoading = true;
      this.processLoadedServices([this.prefetchedTourCombiService], true);
      return;
    }

    const payload: {
      store_id: number,
      worker_id?: number,
      worker_ids?: number[],
      appointment_services_uuids: string[],
      postcode?: string,
    } = {
      store_id: this.appointmentState.store,
      appointment_services_uuids: this.appointmentService.appointment_services_uuids,
    };

    // Coerced at the point of use — the @Input can hold a string from a widget attribute, and
    // Angular may re-set it after ngOnInit normalised it.
    const selectedWorkerId = this.toOptionalNumber(this.selectedWorkerId);

    if (this.isWorkerSubsetActive()) {
      // Subset (discovery): BE filters services + services_workers to the pool; no scalar worker_id.
      payload.worker_ids = this.selectedWorkerIds;
    } else if (selectedWorkerId !== undefined) {
      // Only send the key when a worker was actually selected — an unconditional Number() here
      // sent NaN, which serialises to null and asserts a worker scope the widget does not have.
      payload.worker_id = selectedWorkerId;
    }

    // pass postcode to get mapped workers
    if (this.widgetUtilService?.zipCode) {
      payload.postcode = this.widgetUtilService?.zipCode;
    }

    this.isServicesLoading = true;
    this.formService.getAppointmentServices(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (services) => this.processLoadedServices(services),
        error: (error: HttpErrorResponse) => {
          this.isServicesLoading = false;
          this.servicesResolved.set(true);
          this.servicesLoadFailed.set(true);
          this.customEventService.servicesLoadedEvent.emit();
          LoggerService.error(error);
        }
      });
  }

  private processLoadedServices(services: AppointmentServiceDao[], skipInternalFilter = false): void {
    this.isServicesLoading = false;
    this.servicesResolved.set(true);
    !services && (services = []);
    if (!skipInternalFilter) {
      !this.globals.isInternal && (services = services?.filter(service => service.is_internal !== 1));
    }

    if (this.hardCodedSelectedAppointmentServiceIds?.length) {
      const hasAtLeastSinglePreselectedService = services.find(service => this.hardCodedSelectedAppointmentServiceIds.includes(service.id.toString()));
      if (!hasAtLeastSinglePreselectedService) {
        this.appointmentServicesAvailable = [];
        return;
      } else {
        this.appointmentServicesAvailable = services;
      }
    } else {
      this.appointmentServicesAvailable = services;
    }

    this.conferenceState?.uuid && (this.hideResourceStep = true);
    const categoryWiseServiceMapping = new Map<number, AppointmentServiceDao[]>();
    const categorizedService = Array<AppointmentServiceCategoryModel>();
    const unavailableServiceIds: string[] = [];
    const unavailableAppointmentServiceCategoryIds = Array<string>();

    this.resetSelectedAppointmentServiceIds();
    this.resetSelectedAppointmentServiceCategoryIds();

    // BE already filters to the pool — kept as defense-in-depth. An empty result is surfaced by
    // the services step's own empty state, which keeps the store selector usable; flagging it
    // here as well would render two messages for one situation.
    if (this.isWorkerSubsetActive()) {
      services = services?.filter(service =>
        (service.services_workers ?? []).some(sw => this.selectedWorkerIds.includes(sw.worker_id))
      );
    }

    services?.forEach(service => {
      const serviceWorkersArray = Array<number>();
      if (service.appointment_service_category?.id) {
        categoryWiseServiceMapping.set(service.appointment_service_category.id, []);
      }

      service.services_workers?.forEach(servicesWorker => {
        const workerId = servicesWorker.worker_id;
        serviceWorkersArray.push(workerId);

        // Add worker in all workers array if not exist AND belongs to current store
        if (
          servicesWorker.worker != null &&
          !(workerId in this.allWorkerObjects) &&
          (!servicesWorker.worker?.location_dependency || workerServesStore(servicesWorker.worker, this.appointmentState.store)) &&
          servicesWorker.worker.bookable
        ) {
          this.allWorkerObjects.set(workerId, servicesWorker.worker);
        }
      });

      // Set values in workers per service map. De-duplicated: a worker who offers the
      // service at more than one store now has one row per store, and the same person
      // appearing twice breaks the worker step (it stops auto-skipping for a single
      // worker and renders the card twice).
      this.workersIdsPerService.set(service.id, [...new Set(serviceWorkersArray)]);
    });

    services?.forEach(service => {
      // Set values for categorized a services
      if (service.appointment_service_category?.id) {
        categoryWiseServiceMapping
          .get(service.appointment_service_category.id)
          ?.push(service);
      }
    });

    categoryWiseServiceMapping.forEach(categoryWiseServices => {
      if (categoryWiseServices?.length) {
        const service = categoryWiseServices[0];
        categorizedService.push({
          category: service.appointment_service_category.name,
          appointmentServiceCategory: service.appointment_service_category,
          aServicesOfCat: categoryWiseServices,
          position: service.appointment_service_category.position,
          is_multi_language: service.is_multi_language,
          _translations: service.is_multi_language ? service._translations : [],
        });
      }
    });

    this.appointmentServicesByCat = this.helperService.sortByNumber(categorizedService, 'position');

    if (this.selectedAppointmentServiceIds?.length) {
      // When multiple services are selected, remove combi service IDs from selectedAppointmentServiceIds
      if (this.selectedAppointmentServiceIds?.length > 1) {
        const combiServiceIdSet = new Set<number>(
          services.filter(s => s?.is_combi).map(s => s.id)
        );

        // Remove combi services from selection
        this.selectedAppointmentServiceIds = this.selectedAppointmentServiceIds.filter(serviceId => {
          if (combiServiceIdSet.has(Number(serviceId))) {
            LoggerService.warn(`Removing combi service id ${serviceId} from selectedAppointmentServiceIds because combining services and combos is not allowed`);
            return false;
          }
          return true;
        });
      }

      this.selectedAppointmentServiceIds?.forEach(serviceId => {
        const selectedService = services.find(service => Number(service.id) === Number(serviceId));

        // If only one service is selected and it is a combi service, then set isCombiServiceSelected to true
        if (selectedService?.is_combi && this.selectedAppointmentServiceIds?.length === 1) {
          this.appointmentState.isCombiServiceSelected = true;
        }

        if (selectedService) {
          if (!this.appointmentState.services?.includes(selectedService.id)) {
            this.appointmentState.services.push(selectedService.id);
          } {
            LoggerService.warn(`selected service id is already exist in state so ignoring entry.`);
          }
        } else {
          LoggerService.warn(`selected service id is not available. Removing ${serviceId} from the selected services array.`);
          unavailableServiceIds.push(serviceId);
        }
      });

      this.selectedAppointmentServiceIds = this.selectedAppointmentServiceIds.filter(
        serviceId => unavailableServiceIds.indexOf(serviceId) === -1
      );

      if (this.selectedAppointmentServiceIds?.length == 0 && services?.length) {
        this.selectedAppointmentServiceIds = [services[0].id + ''];
        this.appointmentState.services.push(services[0].id);
        LoggerService.warn(`hard coded service id is not available. So pre-selecting first service.`);
      }
    }

    if (this.selectedAppointmentServiceCategoryIds?.length) {
      this.selectedAppointmentServiceCategoryIds.forEach(serviceId => {
        if (serviceId) {
          !this.appointmentState.categories && (this.appointmentState.categories = []);
          this.appointmentState.categories.push(Number(serviceId));
        } else {
          LoggerService.warn(`selected service id is not available. Removing ${serviceId} from the selected services array.`);
          unavailableAppointmentServiceCategoryIds.push(serviceId);
        }
      });

      this.selectedAppointmentServiceCategoryIds = this.selectedAppointmentServiceCategoryIds.filter(
        serviceId => unavailableAppointmentServiceCategoryIds.indexOf(serviceId) === -1
      );
    }

    this.afterAppointmentServiceToggled();

    if (this.hasQualificationQuestions && this.hasQualificationQuestionsAnswered) {
      this.appointmentService.resetAppointmentCategoryWiseListEvent.emit();
    }

    if (this.appointmentState.services.length) {
      this.updateAvailableWorkers();
    } else {
      this.noServices = true;
    }

    // If no bookable workers available clear local storage
    if (!this.allWorkerObjects.size) {
      this.resetForm();
      this.noWorkers = true;
      this.formReseted = false;
    }

    // Preselecting worker
    if (
      (this.selectedWorkerId || Number(this.selectedWorkerId) === 0 || this.isWorkerSubsetActive()) &&
      this.selectedAppointmentServiceIds?.length > 0 &&
      (!this.hasQualificationQuestions || this.skipQualificationQuestion)
    ) {
      LoggerService.log('[Debug] WorkerID and ServiceID both are present so pre-selecting a worker');
      this.preselectWorker();
    }

    // Tour flow: combi service is resolved via /prepare, skip the services step entirely
    if (this.enteredAppointmentFromTour && this.appointmentState.services.length) {
      LoggerService.log('[tour] auto-advancing past services step');
      this.handleMeetingOrDateNavigation(true);
    }

    this.customEventService.servicesLoadedEvent.emit();
  }

  // A multi-worker subset is active when 2+ ids were preselected via selected-worker-ids.
  private isWorkerSubsetActive(): boolean {
    return Array.isArray(this.selectedWorkerIds) && this.selectedWorkerIds.length >= 2;
  }

  preselectWorker() {
    // identify whether action is automatic or manual
    let isFirstTime = true;
    if (this.appointmentState?.date !== null) {
      isFirstTime = false;
    }

    if (this.workersAvailable.length === 0) {
      this.appointmentState.worker = 0;
      this.onWorkerSelected();
      this.handleMeetingOrDateNavigation(isFirstTime);
    } else if (this.workersAvailable.length === 1) {
      this.partner.hide_resource_step = 1;
      this.appointmentState.worker = this.workersAvailable[0]['id'];
      this.onWorkerSelected();
      this.handleMeetingOrDateBackNavigation(isFirstTime);
    } else {
      if (this.isWorkerSubsetActive()) {
        // Anyone-within-subset: worker=0 is the internal sentinel, mapped to the subset
        // array on the availability call — never random-pick a single worker.
        this.partner.hide_resource_step = 1;
        this.appointmentState.worker = 0;
        this.onWorkerSelected();
        this.handleMeetingOrDateNavigation(isFirstTime);
      } else if (this.partner.is_round_robin_feature_enabled === 1) {
        LoggerService.warn('[Debug] Selecting random worker according to the round robin');
        if (this.workersAvailable.length > 0) {
          const worker: any = this.helperService.get_random(
            this.workersAvailable
          );
          this.selectWorker(worker.id);
          this.handleMeetingOrDateNavigation(isFirstTime);
        } else {
          this.selectWorker(0);
          this.handleMeetingOrDateNavigation(isFirstTime);
        }
      } else if (this.selectedWorkerId) {
        const selectedWorker: UserDao = this.workersAvailable.find(
          (worker: UserDao) => {
            return Number(worker.id) === Number(this.selectedWorkerId);
          }
        );

        if (selectedWorker) {
          this.partner.hide_resource_step = 1;
          this.appointmentState.worker = selectedWorker.id;
          this.onWorkerSelected();
          this.handleMeetingOrDateNavigation(isFirstTime);
        }
      } else if (Number(this.selectedWorkerId) === 0) {
        this.partner.hide_resource_step = 1;
        this.appointmentState.worker = 0;
        this.onWorkerSelected();
        this.handleMeetingOrDateNavigation(isFirstTime);
      }
    }
  }

  handleMeetingOrDateNavigation(isFirstTime: boolean): void {
    if (this.appointmentState?.has_meeting_types_restrictions) {
      this.navigateTo(APPOINTMENT_CONSTANT.MEETING_PROVIDERS);
    } else {
      this.navigateTo(APPOINTMENT_CONSTANT.DATE, isFirstTime);
    }
  }

  private continueFromSkippedWorkerStep(isFirstTime: boolean): void {
    if (this.viewMode === APPOINTMENT_CONSTANT.DATE || this.viewMode === APPOINTMENT_CONSTANT.MEETING_PROVIDERS) {
      this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT, isFirstTime);
    } else {
      this.handleMeetingOrDateNavigation(isFirstTime);
    }
  }

  handleMeetingOrDateBackNavigation(isFirstTime: boolean): void {
    if (this.appointmentState?.has_meeting_types_restrictions === true) {
      if (this.backButtonClicked) {
        this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT);
      } else {
        this.navigateTo(APPOINTMENT_CONSTANT.MEETING_PROVIDERS);
      }
    } else {
      if (this.backButtonClicked) {
        this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT);
      } else {
        this.navigateTo(APPOINTMENT_CONSTANT.DATE, isFirstTime);
      }
    }
  }

  onNewStoresEvent(stores: StoresDao[]) {
    this.stores = stores;
  }

  onServiceChange({ event, service }: { event: Event, service: AppointmentServiceDao }): void {
    if ((event.target as HTMLInputElement).checked) {
      if (service.is_combi || this.partner.allow_multiple_services_bookings !== 1) {
        this.appointmentState.services = [service.id];
      } else {
        this.appointmentState.services.push(service.id);
      }
    } else {
      this.appointmentState.services.splice(this.appointmentState.services.indexOf(service.id), 1);

      this.localStorageService.getItem(this.CART_LS_NAME, (savedCartState: CartItem[]) => {
        if (savedCartState) {
          let updatedCartList = savedCartState.filter(cartState =>
            !cartState.servicesIds.includes(service.id)
          );

          if (service?.related_appointment_service_id) {
            updatedCartList = savedCartState.filter(cartState =>
              !cartState.servicesIds.includes(service.related_appointment_service_id)
            );
          }

          this.cart = updatedCartList;
          this.utilService.updateLocalStorage(this.CART_LS_NAME, updatedCartList);

          if (updatedCartList.length === 0) {
            this.calendarSlotsCountList = [];
          } else if (updatedCartList.length > 0) {
            const updatedCalendarSlotsCountList = Array<{ date: Date; slotsCount: number; }>();

            for (const updatedCart of updatedCartList) {
              const foundedCalendarSlotsCountList = this.calendarSlotsCountList.filter(calendarSlot =>
                updatedCart.date.toString() === calendarSlot.date.toString()
              );

              updatedCalendarSlotsCountList.concat(foundedCalendarSlotsCountList);
            }

            this.calendarSlotsCountList = updatedCalendarSlotsCountList;
          }
        }
      });
    }

    this.exceptionWorkers = [];

    this.updateIsCombiServiceSelectedStatus();
    this.afterAppointmentServiceToggled();
  }

  private updateIsCombiServiceSelectedStatus(): void {
    if (this.appointmentState.services.length === 0) {
      this.appointmentState.isCombiServiceSelected = false;
      return;
    }

    this.appointmentState.isCombiServiceSelected = this.appointmentState.services.some(serviceId => {
      const service = this.appointmentServicesAvailable.find(s => s.id === serviceId);
      return service?.is_combi;
    });
  }

  afterAppointmentServiceToggled() {
    this.updateAvailableWorkers();
    // this.updateAppointmentCustomFields();

    this.cdr.detectChanges();

    // If there is just one worker available then preselect that worker as worker tab will be hidden
    if (this.workersAvailable?.length === 1) {
      this.appointmentState.worker = this.workersAvailable[0]['id'];
      this.onWorkerSelected();
    }
  }

  onWorkerSelected(refreshCalendar = false): void {
    this.freeAppointments = [];

    if (this.workersAvailable && this.workersAvailable.length > 0) {
      const foundedWorker = this.workersAvailable.find(worker => worker.id === this.appointmentState.worker);
      this.selectedWorker = foundedWorker || undefined;
    }
    if (this.selectedWorker && this.appointmentState.services.length) {
      const service = this.appointmentServicesAvailable?.find(service => service.id === this.appointmentState.services[0]);
      this.appointmentState.has_meeting_types_restrictions = service?.has_meeting_types_restrictions;
    }

    this.calendarLoaded = false;

    this.resetCalendarData();
    refreshCalendar && this.customEventService.refreshCalendarEvent.emit();
  }

  autoLoadBookableDates() {
    const timezone = this.userState.timezone || this.timezoneService.getLocalTimezone();
    const nowInCurrentTz = moment.tz(timezone);

    const minDate = new Date(nowInCurrentTz.startOf('month').format(DATE_TIME_ISO_T_FORMAT));
    minDate.setHours(0, 0, 0, 0);
    const maxDate = new Date(nowInCurrentTz.add(this.partner.future_booking_threshold_appointments, 'days').format(DATE_TIME_ISO_T_FORMAT));
    maxDate.setHours(23, 59, 59, 999);

    this.automaticBookableDateProcessIsEnabled = true;
    const isNextPressed = this.customEventService.eventCalendarIsNextPressed;
    const isPreviousPressed = this.customEventService.eventCalendarIsPreviousPressed;

    const currMonthDate = new Date(
      this.viewDate.getFullYear(),
      ([true, undefined].includes(isNextPressed) ? this.viewDate.getMonth() + 1 : this.viewDate.getMonth() - 1),
      1
    );

    if (currMonthDate >= minDate && currMonthDate < maxDate) {
      LoggerService.log(`[Debug] Booking date is not available. Jump to ${isPreviousPressed ? 'previous' : 'next'} month.`);

      this.viewDate = new Date(
        this.viewDate.getFullYear(),
        ([true, undefined].includes(isNextPressed) ? this.viewDate.getMonth() + 1 : this.viewDate.getMonth() - 1),
        1
      );

      this.monthChanged = true;
      this.updateCalendarPrevState(this.viewDate);
      this.calendarLoaded = false;
    } else {
      this.calendarLoaded = true;
      this.automationBookingDatesLimitReached = true;

      // reset flags of next and previous calendar button
      LoggerService.log('[Reset flags of next and previous calendar button]');
      this.customEventService.eventCalendarIsNextPressed = undefined;
      this.customEventService.eventCalendarIsPreviousPressed = undefined;
    }
  }

  resetCalendarData(): void {
    this.monthChanged = false;
    this.lastCalendarMonth = undefined;
  }

  // The method called when you go to the calendar page
  markExceptionDays({ body }: { body: CalendarMonthViewDay[] }) {
    const timezone = this.userState.timezone || this.timezoneService.getLocalTimezone();
    const nowInCurrentTz = moment.tz(timezone);

    // Workaround: prevent executing twice;
    // Bug: when calendar month is changed this function is executed twice. Once with previous month days set,
    // and second time with current month day set
    // Solution: keep last month number and execute this just if body date is not equal to month number of previous month

    // Commented following code as  let reload same month on timezone change
    // if (this.monthChanged && this.lastCalendarMonth === body[10].date.getMonth()) {
    //   LoggerService.warn('Not loading calendar');
    //   return false;
    // }

    // Unsubscribe previous request in case still in progress
    this.getDaysWiseFreeSlots$?.unsubscribe();
    this.calendarLoaded = false;
    this.showAppointmentSlots = false;

    this.lastCalendarMonth = body[10].date.getMonth();
    let dayOfMonth: string;
    const maxDate = new Date(nowInCurrentTz.add(this.partner.future_booking_threshold_appointments, 'days').format(DATE_TIME_ISO_T_FORMAT));
    maxDate.setHours(23, 59, 59, 999);
    const nowTz = new Date(moment.tz(timezone).format(DATE_TIME_ISO_T_FORMAT));
    let startDateContextMoment: moment.Moment;
    let endDateContextMoment: moment.Moment;

    if (moment(body[10].date).isSame(nowTz, 'month')) {
      dayOfMonth = moment(nowTz).format(this.dateIsoFormat);
    } else {
      dayOfMonth = moment(body[10].date).tz(timezone).startOf('month').format(this.dateIsoFormat);
    }

    if (this.dateContext && this.dateContextStart && this.dateContextEnd) {
      startDateContextMoment = moment(this.dateContext, this.dateIsoFormat).tz(timezone).subtract(this.dateContextStart, 'days');
      endDateContextMoment = moment(this.dateContext, this.dateIsoFormat).tz(timezone).add(this.dateContextEnd, 'days');

      if (startDateContextMoment.isBefore(moment().tz(timezone))) {
        if (endDateContextMoment.isSameOrAfter(moment().tz(timezone))) {
          if (moment(body[10].date).isSame(nowTz, 'month')) {
            dayOfMonth = moment(nowTz).format(this.dateIsoFormat);
          } else {
            dayOfMonth = moment(body[10].date).tz(timezone).startOf('month').format(this.dateIsoFormat);
          }
        } else {
          dayOfMonth = moment(this.dateContext).tz(timezone).format(this.dateIsoFormat);
        }
      } else {
        const firstDateOfMonth = moment(body[10].date).tz(timezone).startOf('month');
        if (firstDateOfMonth.isAfter(startDateContextMoment)) {
          dayOfMonth = firstDateOfMonth.format(this.dateIsoFormat);
        } else {
          dayOfMonth = moment(this.dateContext).tz(timezone).format(this.dateIsoFormat);
        }
      }

      const endOfMonthMomentObj = moment(body[10].date).tz(timezone).endOf('month');
      if (endDateContextMoment.isBefore(endOfMonthMomentObj)) {
        this.customEventService.disableCalendarNextButtonEvent.emit(true);
      }
    }

    // Get worker needs to be passed to free_availabilities API
    let freeAvailabilitiesWorker: number | number[] = 0;
    if (this.conferenceState?.uuid === undefined) {
      if (this.selectedWorkerId && Number(this.selectedWorkerId) > 0) {
        freeAvailabilitiesWorker = Number(this.selectedWorkerId);
      } else if (this.isWorkerSubsetActive()) {
        // A picked in-subset worker wins (scalar); otherwise send the subset array —
        // the embed config outranks any persisted default worker.
        const pickedWorker = Number(this.appointmentState.worker);
        freeAvailabilitiesWorker = (pickedWorker > 0 && this.selectedWorkerIds.includes(pickedWorker))
          ? pickedWorker
          : this.selectedWorkerIds;
      } else if (this.appointmentState.default_worker_id) {
        freeAvailabilitiesWorker = Number(this.appointmentState.default_worker_id);
      } else if (this.appointmentState.worker) {
        freeAvailabilitiesWorker = Number(this.appointmentState.worker);
      }
    }

    // pass postcode to get mapped workers
    let postcode = undefined;
    if (this.partner.enable_store_postcode_feature === 1 && this.widgetUtilService?.zipCode) {
      postcode = this.widgetUtilService?.zipCode;
    }

    this.getDaysWiseFreeSlots$ = this.formService.getDaysWiseFreeSlots(
      freeAvailabilitiesWorker,
      this.appointmentState.store,
      this.appointmentState.services.toString(),
      dayOfMonth,
      this.globals.isInternal,
      (this.conferenceState?.uuid ? this.conferenceState.uuid : undefined),
      this.globals.debugMode,
      this.globals.internalToken,
      this.appointmentState.has_meeting_types_restrictions && this.appointmentState.meeting_type_id,
      this.exceptionWorkers?.length && this.exceptionWorkers,
      postcode,
      this.partner?.is_timezone_enabled ? this.effectiveDisplayTimezone : undefined
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: availableSlots => {
        this.getDaysWiseFreeSlots$.unsubscribe();
        this.calendarDate = true;
        this.availableSlotsArray = [];
        let bookingDateIsAvailable = true;
        let isDebugModeOn = false;
        if (availableSlots && !('errors' in availableSlots)) {
          // Debug mode is on and debug data is presents, prepare calendar from debug data instead of actual availabilities
          isDebugModeOn = (
            this.globals.debugMode &&
            this.troubleshootingModeEnabled &&
            Object.keys(availableSlots.debug.workers_appointments_slots).length
          ) ? true : false;

          if (isDebugModeOn) {
            // rehydrate object
            availableSlots = new DayWiseFreeSlotsDao(
              availableSlots.available_minutes_blocks,
              availableSlots.debug
            );

            this.debugCommonNotes = availableSlots.getCommonNotes();

            // Fetch selected store
            const selectedStore = this.stores.find(store => store.id === this.appointmentState.store);

            // Get first worker key and generate slots accordingly
            const firstWorkerIdKey = Object.keys(availableSlots.debug.workers_appointments_slots)[0];

            // Preparing slots based on first worker from debug data
            availableSlots.debug.workers_appointments_slots[firstWorkerIdKey].forEach(workerDayWiseSlots => {
              workerDayWiseSlots.appointments_slots.forEach(slot => {
                this.availableSlotsArray[workerDayWiseSlots.date] ??= [];
                this.availableSlotsArray[workerDayWiseSlots.date].push({
                  start: slot.appointment_start,
                  end: slot.appointment_end,
                  worker: firstWorkerIdKey,
                  workerUuids: [],
                  combiServiceWorkersMapping: {},
                  store: selectedStore,
                  startHour: parseInt(slot.appointment_start.split(' ')[1].split(':')[0], 10),
                  short_start: slot.appointment_short_start,
                  location: undefined,
                  isReserved: false,
                  is_bookable: availableSlots.getSlotAvailability(`${workerDayWiseSlots.date}|${slot.appointment_short_start}`),
                  notes: availableSlots.getDayWiseNotes(`${workerDayWiseSlots.date}|${slot.appointment_short_start}`)
                });
              });
            });
          } else {
            // Identify selected services has requested resources (means that service is with room booking)
            let selectedServices = new Array<AppointmentServiceDao>();
            this.appointmentServicesByCat.forEach(category => {
              const foundServices = category.aServicesOfCat.filter(service => this.appointmentState.services.includes(service.id))
              foundServices && (selectedServices = [...selectedServices, ...foundServices]);
            });
            const hasResourcesRequestedServices = selectedServices.find(service => service.is_resources_requested);
            const hasResourcesRequested = hasResourcesRequestedServices ? true : false;

            // preparing array that has day wise availabilities
            availableSlots.available_minutes_blocks?.forEach(daysWiseSlots => {
              daysWiseSlots.workers_minutes_blocks?.forEach(workerMinutesBlock => {
                workerMinutesBlock.minutes_blocks.forEach(availabilities => {
                  availabilities.appointments_slots?.forEach(slot => {
                    let workerUuids = Array<string>();
                    // Slot mapping is anyone-mode: each slot carries its own resolved worker's uuid.
                    const isSubsetRequest = Array.isArray(freeAvailabilitiesWorker);
                    const isAnyoneOptionSelected = this.conferenceState?.uuid === undefined
                      && (freeAvailabilitiesWorker === 0 || isSubsetRequest);

                    // Pass worker from worker object only when anyone with normal booking case except that like
                    // room booking, booking + anyone, conference all the workers uuid from workers array will be passed
                    if (isAnyoneOptionSelected && !hasResourcesRequested) {
                      workerUuids = [workerMinutesBlock.worker.uuid];
                    } else {
                      workerUuids = workerMinutesBlock.workers.map(worker => worker.uuid);
                    }

                    !this.availableSlotsArray[daysWiseSlots.date] && (this.availableSlotsArray[daysWiseSlots.date] = []);

                    this.availableSlotsArray[daysWiseSlots.date].push({
                      start: slot.appointment_start,
                      end: slot.appointment_end,
                      worker: workerMinutesBlock.worker,
                      workerUuids,
                      combiServiceWorkersMapping: workerMinutesBlock.combi_workers || {},
                      store: workerMinutesBlock.store,
                      startHour: parseInt(slot.appointment_start.split(' ')[1].split(':')[0], 10),
                      short_start: slot.appointment_short_start,
                      location: slot.location,
                      isReserved: slot.is_reserved,
                      is_bookable: true
                    });
                  });
                });
              });
            });
          }
        }

        bookingDateIsAvailable = (Object.keys(this.availableSlotsArray)?.length > 0);

        body.forEach(date => {

          const formattedDate = this.utilService.dateToStr(date.date);
          let dateDisabled = false;
          let debugDayStatus: number; // Default value will be undefined

          (this.days.length < 7) && this.days.push(date);

          // If debug mode is on get whole day status and set in debug meta data of date
          if (isDebugModeOn) {
            debugDayStatus = availableSlots.getDayAvailability(formattedDate);
            date.meta = {
              dayStatus: (debugDayStatus ?? 0)
            };
          }

          if (
            date.isPast || // if date is in past
            date.date > maxDate || // date is bigger than max date
            !this.availableSlotsArray[formattedDate] // date is not present in available dates array
          ) {
            dateDisabled = true;
          }


          if (!dateDisabled && startDateContextMoment && endDateContextMoment) {
            if (moment(date.date).isBetween(startDateContextMoment, endDateContextMoment, undefined, '[]')) {
              if (!moment(date.date).isSameOrAfter(nowTz, 'day')) {
                dateDisabled = true;
              }
            } else {
              dateDisabled = true;
            }
          }

          if (!dateDisabled && !this.dateContext && this.calendarPreselectedDate) {
            const calendarPreselectedDateTz = new Date(moment.tz(this.calendarPreselectedDate, timezone).format(DATE_TIME_ISO_T_FORMAT));
            if ((date.date < calendarPreselectedDateTz) || (date.date > calendarPreselectedDateTz)) {
              dateDisabled = true;
            }
          }

          if (dateDisabled) {
            date.cssClass = 'cal-disabled';
            date.isWeekend = isDebugModeOn ? debugDayStatus === undefined : true;
          }

          // date context is present and current date is same then preselect date
          if (!dateDisabled && this.appointmentState.date !== null && date.date.toDateString() === new Date(this.appointmentState.date).toDateString()) {
            this.dayClicked({ day: date });
          }
        });

        if (!bookingDateIsAvailable) {
          const isAutoSearchEnabled = Number(this.partner.disable_automatic_search) !== 1;
          const shouldAutoLoad = !endDateContextMoment || moment.tz(timezone)
            .set('month', this.lastCalendarMonth)
            .startOf('month')
            .isBefore(endDateContextMoment);

          this.showBookableDateNotAvailableIssue = !isAutoSearchEnabled || !shouldAutoLoad;
          this.automaticBookableDateProcessIsEnabled = isAutoSearchEnabled && shouldAutoLoad;

          if (this.automaticBookableDateProcessIsEnabled) {
            this.autoLoadBookableDates();
          } else {
            // Reset calendar navigation flags
            LoggerService.log('[Reset flags of next and previous calendar button]');
            this.customEventService.eventCalendarIsNextPressed = undefined;
            this.customEventService.eventCalendarIsPreviousPressed = undefined;
          }
        }

        this.checkForWidgetCalendarNotice();
        this.calendarLoaded = true;
      },
      error: error => {
        // Render the calendar with nothing free rather than leaving the loader up.
        // `calendarLoaded = false` keeps the spinner on screen forever and hides the
        // month entirely (calendar-picker.component.html:261-267), so any failed
        // request — a stale worker id in a bookmarked link, a dropped connection —
        // looked like the widget had hung. An empty month is the same thing a fully
        // booked month shows, and the customer can still page to another one.
        this.availableSlotsArray = [];
        this.calendarDate = true;
        this.calendarLoaded = true;
        this.getDaysWiseFreeSlots$?.unsubscribe();
        LoggerService.error(error);
      }
    });

  }
  // Before calendar render

  // On next prev month
  viewDateChanged(event: { viewDate: Date; isNext: boolean }): void {
    this.customEventService.eventCalendarIsNextPressed = event.isNext;
    this.customEventService.eventCalendarIsPreviousPressed = !event.isNext;
    this.viewDate = event.viewDate;
    this.automaticBookableDateProcessIsEnabled = false;
    this.monthChanged = true;
    this.updateCalendarPrevState(event.viewDate);
    this.calendarLoaded = false;
    this.automationBookingDatesLimitReached = false;
    this.showBookableDateNotAvailableIssue = false;
  }

  // Get slots when calendar day clicked
  dayClicked({ day }: { day: CalendarMonthViewDay }) {
    const formattedDate = this.utilService.dateToStr(day.date);

    if (day.isWeekend || day.isPast || day.date === this.appointmentState.date || (!this.availableSlotsArray[formattedDate] && !this.globals.debugMode)) {
      LoggerService.warn('[Debug] The selected date is not available due to it being a weekend, in the past, disabled, or chosen already.');
      return false;
    }

    this.appointmentState.day = day;
    this.appointmentState.date = day.date;
    this.freeAppointments = [];
    this.showAppointmentSlotGhostElement = 1;
    this.noAppointments = false;

    day.cssClass += ' cal-selected';
    day.badgeTotal = 0;

    this.old_select_calendar?.badgeTotal === 0 && (this.old_select_calendar.cssClass = '');

    const cartSupported = this.widgetUtilService.getWidgetConf().cartSupported;

    if (!cartSupported) {
      this.cart = [];
      this.CALENDAR_SLOTS_COUNT_LS_NAME = [];
      this.calendarSlotsCountList = [];
      if (this.old_select_calendar) {
        this.old_select_calendar.cssClass = '';
        this.old_select_calendar.badgeTotal = 0;
      }
    }

    this.old_select_calendar = day;

    this.getFreeAppointments(formattedDate);
  }

  getFreeAppointments(date: string) {
    let freeAppointments: AppointmentsSlotsDao[] = this.availableSlotsArray[date];
    this.freeAppointmentsCount = freeAppointments.length;
    !freeAppointments?.length && (this.noAppointments = true);
    freeAppointments = freeAppointments.sort((a, b) => Number(a.short_start) - Number(b.short_start));


    let tempFreeAppointments: {
      dayPeriod: string;
      appointments: AppointmentsSlotsDao[];
      showDayPeriodLabel?: boolean;
      widgetGroup: WidgetAppointmentGroupModel;
      loadMore: boolean
    }[] = [];

    if (this.widgetGroups?.length) {
      this.widgetGroups?.forEach(widgetGroup => {
        tempFreeAppointments.push({
          dayPeriod: widgetGroup.name,
          appointments: [],
          showDayPeriodLabel: false,
          widgetGroup: widgetGroup,
          loadMore: false
        });
      });
    }

    tempFreeAppointments.push({
      dayPeriod: undefined,
      appointments: [],
      showDayPeriodLabel: false,
      widgetGroup: undefined,
      loadMore: false
    });

    if (this.widgetGroups?.length) {
      const notGroupedAppointments: AppointmentsSlotsDao[] = [];
      for (let i = 0; freeAppointments.length > i; i++) {
        for (const freeAppointmentGroup of tempFreeAppointments) {
          if (freeAppointmentGroup.widgetGroup) {
            const freeAppointmentStart = moment(moment().format(this.dateIsoFormat) + ' ' + moment(freeAppointments[i].start).format(TIME_FORMAT), this.dateTimeIsoFormat).toDate();
            const freeAppointmentEnd = moment(moment().format(this.dateIsoFormat) + ' ' + moment(freeAppointments[i].end).format(TIME_FORMAT), this.dateTimeIsoFormat).toDate();

            let widgetGroupStart = moment(freeAppointmentGroup.widgetGroup.start, this.dateTimeIsoFormat).toDate();
            let widgetGroupEnd = moment(freeAppointmentGroup.widgetGroup.end, this.dateTimeIsoFormat).toDate();
            widgetGroupStart = moment(moment().format(this.dateIsoFormat) + ' ' + moment(widgetGroupStart).format(TIME_FORMAT), this.dateTimeIsoFormat).toDate();
            widgetGroupEnd = moment(moment().format(this.dateIsoFormat) + ' ' + moment(widgetGroupEnd).format(TIME_FORMAT), this.dateTimeIsoFormat).toDate();

            if (moment(widgetGroupStart).isAfter(moment(widgetGroupEnd))) {
              widgetGroupEnd = moment(widgetGroupEnd).add(1, 'day').toDate();
              if (
                (
                  moment(freeAppointmentStart).isSameOrAfter(moment(widgetGroupStart)) ||
                  moment(freeAppointmentStart).add(1, 'day').isBetween(moment(widgetGroupStart), moment(widgetGroupEnd), undefined, '[]')
                ) &&
                moment(freeAppointmentEnd).isSameOrBefore(moment(widgetGroupEnd))
              ) {
                freeAppointments[i].isGrouped = true;
                freeAppointmentGroup.appointments.push(freeAppointments[i]);
                freeAppointmentGroup.showDayPeriodLabel = true;
                break;
              }
            } else {
              if (
                moment(freeAppointmentStart).isSameOrAfter(moment(widgetGroupStart)) &&
                moment(freeAppointmentStart).isBefore(moment(widgetGroupEnd))
              ) {
                freeAppointments[i].isGrouped = true;
                freeAppointmentGroup.appointments.push(freeAppointments[i]);
                freeAppointmentGroup.showDayPeriodLabel = true;
                break;
              }
            }
          }
        }

        if (!freeAppointments[i].isGrouped) {
          notGroupedAppointments.push(freeAppointments[i]);
        }
      }

      if (notGroupedAppointments.length) {
        tempFreeAppointments[tempFreeAppointments.length - 1].showDayPeriodLabel = true;
        tempFreeAppointments[tempFreeAppointments.length - 1].appointments = Object.assign([], notGroupedAppointments);
      }
    } else {
      for (let i = 0; freeAppointments.length > i; i++) {
        tempFreeAppointments[tempFreeAppointments.length - 1].showDayPeriodLabel = true;
        tempFreeAppointments[tempFreeAppointments.length - 1].appointments.push(freeAppointments[i]);
      }
    }

    let appointmentOrderIndex = 0;
    tempFreeAppointments?.forEach(tempFreeAppointment => {
      tempFreeAppointment.appointments = tempFreeAppointment.appointments ? tempFreeAppointment.appointments : [];
      appointmentOrderIndex > 9 && (tempFreeAppointment.showDayPeriodLabel = false);

      // Randomize worker order for same time slots if:
      // 1. There are appointments available
      // 2. Worker randomization setting is enabled
      // 3. Duplicate minutes slots removal is disabled
      if (
        tempFreeAppointment.appointments.length > 0 &&
        this.partner.enable_workers_randomize_with_same_time_slots === 1 &&
        this.partner.widget_remove_duplicate_minutes_slots === 0
      ) {
        tempFreeAppointment.appointments = this.randomizeWorkersWithSameTimeSlots(tempFreeAppointment.appointments);
      }

      tempFreeAppointment?.appointments?.forEach(appointment => {
        appointment.appointmentOrderIndex = appointmentOrderIndex++;
      });
    });
    tempFreeAppointments = tempFreeAppointments.filter(item => item?.appointments?.length);
    this.freeAppointments = tempFreeAppointments;
    this.noAppointments = (!freeAppointments || freeAppointments.length === 0);

    setTimeout(() => {
      this.showAppointmentSlots = true;
      this.showAppointmentSlotGhostElement = 2;
      this.appointmentService.resetSlotSettingsEvent.emit()
    }, 500);
  }

  /** Cart functions */
  updateCart(eventData: {
    event: any;
    appointment: AppointmentsSlotsDao;
    ignoreRelatedServiceId: boolean;
    ignoreAppointmentStateServices: boolean;
    relatedServiceId: number;
    relatedAppointmentCardId: number;
    refreshFormAndCartData: boolean;
  }): void {
    const cartSupported = this.widgetUtilService.getWidgetConf().cartSupported;

    this.lastSelectedAppointment = eventData.appointment;
    if (eventData.event.target.checked) {
      let services: number[] = this.appointmentState.services;
      if (
        eventData.ignoreAppointmentStateServices &&
        eventData.relatedServiceId
      ) {
        services = [eventData.relatedServiceId];
      }
      // add item to cart
      if (!cartSupported) {
        this.addToCart(
          eventData.appointment,
          false,
          eventData.ignoreRelatedServiceId,
          services,
          eventData.relatedAppointmentCardId,
          eventData.refreshFormAndCartData
        );
      } else {
        this.addToCart(
          eventData.appointment,
          true,
          eventData.ignoreRelatedServiceId,
          services,
          eventData.relatedAppointmentCardId,
          eventData.refreshFormAndCartData
        );
      }
    } else {
      // remove selected item from cart
      this.removeFromCart(
        this.appointmentService.createCartItemId(
          eventData.appointment,
          this.appointmentState.date
        ),
        false,
        this.appointmentConstant.CALENDAR
      );
    }
  }

  async addToCart(
    appointment: AppointmentsSlotsDao,
    overwrite: boolean,
    ignoreRelatedServiceId: boolean,
    services: number[],
    relatedAppointmentCardId: number,
    refreshFormAndCartData: boolean
  ): Promise<void> {
    const appointmentStateDate: Date = this.appointmentState.date;
    this.cartService.addToCart(
      appointment,
      this.appointmentState,
      this.appointmentServicesAvailable,
      this.CART_LS_NAME,
      this.cart,
      overwrite,
      ignoreRelatedServiceId,
      services,
      relatedAppointmentCardId,
      (cart: CartItem[]) => {
        this.cart = cart;
        this.totalCartDuration = this.cartService.totalCartDuration;
        this.totalCartPrice = this.cartService.totalCartPrice;
        if (!overwrite) {
          this.calendarSlotsCountList = [];
        }
        if (this.calendarSlotsCountList.length === 0) {
          this.calendarSlotsCountList = [{ date: appointmentStateDate, slotsCount: 1 }];
        } else {
          const calendarSlotsCount = this.calendarSlotsCountList.find(calendarSlot => appointmentStateDate.toString() === calendarSlot.date.toString());
          if (calendarSlotsCount) {
            calendarSlotsCount.slotsCount++;
          } else {
            this.calendarSlotsCountList.push({ date: appointmentStateDate, slotsCount: 1 });
          }
        }

        // totalCartPrice just changed above — recompute VAT/gross regardless of
        // refreshFormAndCartData so cartVat/priceAfterCouponReduction never go stale.
        this.calculateCoupon();

        if (refreshFormAndCartData) {
          this.customEventService.cartItemsChangeEvent.emit({
            cart: this.cart,
            type: WIDGET_CONSTANTS.APPOINTMENT,
          });

          this.updateAppointmentCustomFields();
        }

        // Reserve appointment from here only when appointment added to cart is related appointment
        if (relatedAppointmentCardId && refreshFormAndCartData) {
          this.reserveAppointments(false);
        }
      }
    );
  }

  removeFromCart(cartItemId: string, reloadCustomFields?: boolean, mode: string = APPOINTMENT_CONSTANT.SUMMARY): void {
    if (this.adyenPaymentInFlight()) {
      // The payment running now was minted for this cart.
      return;
    }
    this.cartService.removeFromCart(
      cartItemId,
      this.CART_LS_NAME,
      this.cart,
      (cart: CartItem[], deletedItem: CartItem) => {
        // Check if appointment reservation setting is enabled then delete reservation when slot
        // is remove from cart
        if (Number(this.partner.is_appointment_reservation_enabled) === 1 && mode === this.appointmentConstant.SUMMARY) {
          const appointment = this.cart.find(appointment => appointment.cartItemId === cartItemId);
          this.removeReservedAppointment(appointment);
        }

        this.cart = cart;
        this.totalCartDuration = this.cartService.totalCartDuration;
        this.totalCartPrice = this.cartService.totalCartPrice;
        if (this.calendarSlotsCountList.length >= 0) {
          const calendarSlotsCount = this.calendarSlotsCountList.find(calendarSlot => deletedItem?.date?.toString() === calendarSlot.date.toString());

          if (calendarSlotsCount && calendarSlotsCount.slotsCount > 1) {
            calendarSlotsCount.slotsCount--;
          } else {
            this.calendarSlotsCountList = this.calendarSlotsCountList.filter(calendarSlot => {
              return deletedItem.date.toString() !== calendarSlot.date.toString()
            });
            this.appointmentState.day.badgeTotal = 0;
          }
        }

        this.calculateCoupon();

        this.customEventService.cartItemsChangeEvent.emit({
          cart: this.cart,
          type: WIDGET_CONSTANTS.APPOINTMENT,
        });

        if (this.cart.length === 0) {
          if (this.viewMode !== APPOINTMENT_CONSTANT.DATE) {
            this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT)
          } else {
            this.navigateTo(APPOINTMENT_CONSTANT.DATE)
          }
        }

        reloadCustomFields && this.updateAppointmentCustomFields();

        // Refresh list of cross selling services after removing a service
        if (Number(this.partner.show_cross_selling_services_on_summary_step) === 1) {
          this.getCrossSellingServicesByCategory();
        }
      }
    );
  }

  private removeReservedAppointment(appointment: CartItem): void {
    const appointmentBody: AppointmentReservationBody[] = [];
    appointment.servicesIds.forEach(service => {
      appointmentBody.push({
        appointment_service_id: service,
        worker_id: appointment.workerId,
        start_time: appointment.startTime,
        end_time: appointment.endTime,
        timezone: this.userState?.timezone
      });
    });

    this.formService.removeReservedAppointment(appointmentBody).subscribe({
      error: (error: HttpErrorResponse) => {
        LoggerService.warn('[Debug] Failed to remove a reserved appointment');
        LoggerService.error(error);
      }
    });
  }

  // Booking action
  protected validatePersonalFormAndNavigateToSummaryStep(): void {
    // Reset personalFormValid status
    this.formService.personalFormValid = false;

    if (this.appointmentForm.invalid) {
      this.handlePersonalFormInvalidState();
    } else if (!this.handelFriendlyCaptchaValidation()) {
      return;
    } else {
      // Reset personalFormValid status
      this.formService.personalFormValid = true;

      this.navigateTo(APPOINTMENT_CONSTANT.SUMMARY);
    }
  }

  private handlePersonalFormInvalidState(): void {
    this.widgetUtilService.handleFormInvalidState(this.appointmentForm, this.elementRef);
    this.isPaymentBookButtonValidated();
  }

  book(): void {
    // Reset personalFormValid status to true
    this.formService.personalFormValid = false;

    if (this.isValidBooking()) {
    }
  }

  /**
   * Drop-in has really begun a payment (its own `beforeSubmit`), so the attempt is now in flight
   * and a second Book press must not submit it again - a 3DS2 challenge holds this window open
   * for tens of seconds. An incomplete card never reaches here, which is the whole point.
   */
  onAdyenPaymentStarted(): void {
    this.adyenPaymentInFlight.set(true);
  }

  /**
   * Adyen authorised - the one entry point for every Adyen result, so one result can start at most
   * one booking. If Book started this payment, finish that press now. Otherwise the payment was
   * started without it - Enter in a Drop-in card field submits Drop-in by itself, and the hosted
   * page has its own button - and the shopper has been charged with nothing booked: book now,
   * exactly as a press would, unless something would stop that press. Then the payment stays shown
   * as done and the shopper completes the rest and presses Book.
   */
  onAdyenPaid(details: AdyenPaymentDetails): void {
    this.adyenPaymentInFlight.set(false);
    this.adyenPaymentDetails = details;
    if (this.isReservationExpired) {
      // Paid after the reservation ran out (a 3DS challenge or the hosted page can outlast it): no
      // /book on an expired reservation, not even for the Book press that started this payment.
      // Nothing books it, so say what happens to the money - the backend refunds it unbooked.
      this.bookOnceAdyenPaid = false;
      this.bookingErrorMessage = this.translateService.instant(reservationExpiredMessageKey(this.isAdyenPaymentHeld()));
    } else if (this.bookOnceAdyenPaid) {
      this.bookOnceAdyenPaid = false;
      this.book();
    } else if (this.canBookOnItsOwn()) {
      this.submitBooking();
    }
  }

  /**
   * Would a Book press go through now? A booking already on its way disables Book, so a result
   * reported twice cannot send a second /book.
   */
  private canBookOnItsOwn(): boolean {
    return canBookAfterAdyenPayment({
      paymentHeld: this.isAdyenPaymentHeld(),
      bookingBlocked: this.disableBookingButton
        || this.bookButtonLoader
        || this.isInvoiceAddressFormBlockingBooking
        || this.payAgainRequired(),
      reservationExpired: this.isReservationExpired,
      formIncomplete: this.formService.imageUploaded === false
        || !!this.appointmentForm?.invalid
        || !this.bookValidated(),
      captchaPending: isCaptchaChallengePending(this.partner, this.userState),
    });
  }

  /** An Adyen payment is held for this booking: paid, not booked yet. */
  private isAdyenPaymentHeld(): boolean {
    return this.paymentType === this.paymentTypes.ADYEN && !!this.adyenPaymentDetails;
  }

  /**
   * Adyen refused, the shopper cancelled, or the SDK errored. The payment form comes back, so the
   * in-flight latch must come off with it - otherwise the retry the component is offering could
   * never be submitted.
   */
  onAdyenReset(): void {
    this.adyenPaymentInFlight.set(false);
    this.bookOnceAdyenPaid = false;
    this.adyenPaymentDetails = undefined;
    if (this.isReservationExpired) {
      // No payment is held any more, so the refund wording no longer applies.
      this.bookingErrorMessage = this.translateService.instant(reservationExpiredMessageKey(false));
    }
  }

  isValidBooking(): boolean {
    this.widgetUtilService.customerProfile = undefined;
    if (this.formService.imageUploaded === false) {
      LoggerService.warn('[Processing] Image is uploading...');
      this.markFormGroupTouched(this.appointmentForm);
      return false;
    }

    if (this.appointmentForm.invalid) {
      this.handlePersonalFormInvalidState();
      return false;
    }

    if (!this.handelFriendlyCaptchaValidation()) {
      return false;
    }

    // Setting personalFormValid status to true
    this.formService.personalFormValid = true;

    if (this.bookValidated() && this.isPaymentBookButtonValidated()) {
      this.doBooking();
      return true;
    } else {
      return false;
    }
  }

  handelFriendlyCaptchaValidation(): boolean {
    if (this.partner.is_captcha_feature_enabled && this.partner.captcha_type === CAPTCHA_TYPE.FRIENDLY && !this.userState.friendly_captcha_challenge) {
      this.captchaService.friendlyCaptchaValidationRequired.emit(true);
      return false;
    }
    return true;
  }

  private prepareBookingItems(): AppointmentBookItem[] {
    const bookingItems: AppointmentBookItem[] = [];
    this.customFieldValues = { ...this.customFieldValues, ...this.qualificationQuestionsValues };

    // Extract custom field values
    let fieldIds = Object.keys(this.customFieldValues);
    const qualificationQuestionIds = Object.keys(this.qualificationQuestionsValues).map(key => Number(key));
    let rawCustomFieldIds: number[] = this.tempArray.map((i) => i.id);
    rawCustomFieldIds = [...rawCustomFieldIds, ...qualificationQuestionIds];

    if (rawCustomFieldIds?.length > 0) {
      fieldIds = fieldIds.filter((id: any) => {
        return rawCustomFieldIds.indexOf(Number(id)) > -1;
      });
    }

    const customFieldValues: {
      custom_field_id: number;
      type: string;
      value?: any;
      file_ids?: any;
      option_values?: {
        custom_field_option_id: number;
        custom_field_option_value: string;
      }[];
    }[] = [];

    for (let i = 0; i < fieldIds.length; i++) {
      if (this.customFieldValues[fieldIds[i]]?.type === this.bookingCustomFieldTypes.SELECT) {
        if (Array.isArray(this.customFieldValues[fieldIds[i]]?.value)) {
          customFieldValues.push({
            custom_field_id: Number(fieldIds[i]),
            type: this.bookingCustomFieldTypes.SELECT,
            value: this.customFieldValues[fieldIds[i]]?.value,
          });
        } else {
          customFieldValues.push({
            custom_field_id: Number(fieldIds[i]),
            type: this.bookingCustomFieldTypes.SELECT,
            value: [this.customFieldValues[fieldIds[i]]?.value],
          });
        }
      } else if (this.customFieldValues[fieldIds[i]]?.type === this.bookingCustomFieldTypes.CARD_SELECT) {
        customFieldValues.push({
          custom_field_id: Number(fieldIds[i]),
          type: this.bookingCustomFieldTypes.CARD_SELECT,
          value: this.customFieldValues[fieldIds[i]]?.value,
        });
      } else if (this.customFieldValues[fieldIds[i]]?.type === this.bookingCustomFieldTypes.IMAGE_SELECT) {
        customFieldValues.push({
          custom_field_id: Number(fieldIds[i]),
          type: this.bookingCustomFieldTypes.IMAGE_SELECT,
          value: this.customFieldValues[fieldIds[i]]?.value,
        });
      } else if (
        this.customFieldValues[fieldIds[i]]?.type === this.bookingCustomFieldTypes.NUMBER_SELECT
      ) {
        customFieldValues.push({
          custom_field_id: Number(fieldIds[i]),
          type: this.bookingCustomFieldTypes.NUMBER_SELECT,
          value: this.customFieldValues[fieldIds[i]]?.value,
          option_values: this.customFieldValues[fieldIds[i]]?.option_values,
        });
      } else if (this.customFieldValues[fieldIds[i]]?.type === this.bookingCustomFieldTypes.FILE) {
        customFieldValues.push({
          custom_field_id: Number(fieldIds[i]),
          type: this.bookingCustomFieldTypes.FILE,
          file_ids: Object.assign(
            [],
            this.customFieldValues[fieldIds[i]]?.file_ids
          ),
        });
      } else {
        let tempCustomFieldsDao: CustomFieldsDao;
        if (this.tempArray?.length > 0) {
          tempCustomFieldsDao = this.tempArray.find((item) => {
            return Number(item.id) === Number(fieldIds[i]);
          });
        }
        customFieldValues.push({
          custom_field_id: Number(fieldIds[i]),
          type: tempCustomFieldsDao ? tempCustomFieldsDao?.type : '',
          value: this.customFieldValues[fieldIds[i]]?.toString(),
        });
      }
    }

    // Ensure hidden custom fields are included with proper empty values
    const hiddenSelectTypes = [
      this.bookingCustomFieldTypes.SELECT,
      this.bookingCustomFieldTypes.CARD_SELECT,
      this.bookingCustomFieldTypes.IMAGE_SELECT,
      this.bookingCustomFieldTypes.NUMBER_SELECT,
      this.bookingCustomFieldTypes.WORKER_SELECT,
    ];
    for (const hiddenField of this.tempArray.filter(cf => cf.is_hidden === 1)) {
      if (hiddenField.type === this.bookingCustomFieldTypes.FILE) {
        continue;
      }
      const existingIdx = customFieldValues.findIndex(cf => cf.custom_field_id === hiddenField.id);
      if (existingIdx > -1) {
        const entry = customFieldValues[existingIdx];
        if (entry.value === undefined || entry.value === null) {
          entry.value = hiddenSelectTypes.includes(hiddenField.type) ? [] : '';
        } else if (Array.isArray(entry.value) && entry.value.includes(null)) {
          entry.value = entry.value.filter((v: number | null) => v !== null);
        }
      } else {
        customFieldValues.push({
          custom_field_id: Number(hiddenField.id),
          type: hiddenField.type,
          value: hiddenSelectTypes.includes(hiddenField.type) ? [] : '',
        });
      }
    }

    for (const i in this.cart) {
      if (this.cart.hasOwnProperty(i)) {
        const bookingData: AppointmentBookItem = {
          store_id: this.cart[i].storeId,
          store_name: this.cart[i].storeName,
          partnerId: this.partner['id'],
          services: this.cart[i]['servicesIds'].join(),
          referenceServices: this.cart[i]['referenceServices'],
          worker_email: this.cart[i].workerEmail,
          worker_uuids: this.cart[i].workerUuids,
          ...(!this.appointmentState.isCombiServiceSelected ? {
            worker_id: this.cart[i]['workerId']
          } : {}),
          ...(this.appointmentState.isCombiServiceSelected ? {
            combi_workers: this.cart[i].combiServiceWorkersMapping,
            worker_id: Number(Object.values(this.cart[i].combiServiceWorkersMapping)[0])
          } : {}),
          resource_name: this.cart[i].workerName,
          start: this.cart[i]['startTime'],
          end: this.cart[i]['endTime'],
          ...(this.cart[i]['location'] ? { location: this.cart[i]['location'] } : {}),
          title: this.userState.title,
          prename: this.userState.forename,
          birthday: this.userState?.birthday ? moment(this.userState?.birthday).format(DATE_ISO_FORMAT) : undefined,
          gender: this.userState.gender,
          lastname: this.userState.lastName,
          email: this.userState.eMail,
          phone: this.userState.phone,
          mobile: this.userState.mobile,
          comment: this.userState.comment,
          customer_id: this.userState.customerId,
          customer_uuid: this.userState.customerUuid,
          country: this.userState.country_id,
          company_name: (this.userState?.company || undefined),
          internal_comment: (this.userState?.internal_comment || undefined),
          captcha: (this.userState?.captcha_challenge || undefined),
          friendly_captcha: (this.userState?.friendly_captcha_challenge || undefined),
          token: (this.appointmentState?.captcha?.uuid || undefined),
          customer_notification_preference: this.userState.customer_notification_preference,
          meeting_type_id: this.userState.meeting_type_id,
          customFieldValues: customFieldValues,
          user_browser_language: this.globals.user_browser_language,
          user_selected_language: this.globals.user_selected_language,
          coupon_code: this.coupon && !this.isInvalidCoupon ? this.coupon.code : null,
          payment_type: this.paymentType,
          ...(this.paymentType === this.paymentTypes.EXTERNAL_INVOICE && this.invoiceAddressChecked && this.invoiceAddress
            ? { invoice_address: this.invoiceAddress }
            : {}),
          booker_worker_id: this.toOptionalNumber(this.bookerWorkerId),
          amount: (this.cart[i].total.price === -1 ? -1 : this.cart.reduce((acc, item) => acc + item.total.price, 0) + this.customFieldsAddonsPrice),
          appointment_source_id: this.globals?.isInternal ? APPOINTMENT_SOURCE_ID.INTERNAL_WIDGET : APPOINTMENT_SOURCE_ID.EXTERNAL_WIDGET,
          utm_source: ((this.utmSource && this.utmSource !== 'null') ? this.utmSource : undefined),
          utm_content: ((this.utmContent && this.utmContent !== 'null') ? this.utmContent : undefined),
          utm_medium: ((this.utmMedium && this.utmMedium !== 'null') ? this.utmMedium : undefined),
          utm_campaign: ((this.utmCampaign && this.utmCampaign !== 'null') ? this.utmCampaign : undefined),
          utm_term: ((this.utmTerm && this.utmTerm !== 'null') ? this.utmTerm : undefined),
          utm_id: ((this.utmId && this.utmId !== 'null') ? this.utmId : undefined),
          is_internal: this.globals?.isInternal ? true : false,
          ...(this.userState.acceptDataPolicy !== undefined) && { accept_data_policy: +this.userState.acceptDataPolicy },
          ...(this.partner?.show_address_on_widget !== 0 ? {
            street: this.userState.street,
            zip: this.userState.zip,
            city: this.userState.city
          } : {}),
          ...this.partner?.is_timezone_enabled && { timezone: this.effectiveDisplayTimezone },
        };

        if (this.paymentType === this.paymentTypes.PAYPAL) {
          bookingData.paypal_order_id = this.paypalOrderDetail.paypal_order_id;
          bookingData.paypal_payer_id = this.paypalOrderDetail.paypal_payer_id;
          bookingData.paypal_status = this.paypalOrderDetail.paypal_status;
          bookingData.paypal_raw_data = this.paypalOrderDetail.paypal_raw_data;
          bookingData.paypal_capture_id = this.paypalOrderDetail.paypal_capture_id;
          bookingData.paypal_payment_log_id = this.paypalOrderDetail.paypal_payment_log_id;
        } else if (this.paymentType === this.paymentTypes.SAFERPAY) {
          bookingData.saferpay_transaction_id = this.saferPayPaymentDetails.transaction_id;
          bookingData.saferpay_payment_method = this.saferPayPaymentDetails.payment_method;
        } else if (this.paymentType === this.paymentTypes.ADYEN) {
          // Opaque handles only. The backend re-reads the session from Adyen
          // and believes that, never what the browser says was paid.
          bookingData.adyen_session_id = this.adyenPaymentDetails?.session_id;
          bookingData.adyen_session_result = this.adyenPaymentDetails?.session_result;
        } else if (this.paymentType === this.paymentTypes.CREDITCARD) {
          bookingData.stripe_payment_intent_id = this.stripePaymentMethodId ? this.stripePaymentMethodId : null;
        }

        if (this.partner.is_customer_profiles_feature_enabled === 1) {
          bookingData.broker_prename = this.brokerState?.forename;
          bookingData.broker_lastname = this.brokerState?.lastName;
          bookingData.broker_email = this.brokerState?.eMail;
          bookingData.broker_company = this.brokerState?.company;
          bookingData.broker_phone = this.brokerState?.phone;
          bookingData.broker_mobile = this.brokerState?.mobile;
          bookingData.broker_street = this.brokerState?.street;
          bookingData.broker_zip = this.brokerState?.zip;
          bookingData.broker_city = this.brokerState?.city;
        }

        // Additional fields related to conference
        if (this.conferenceState?.uuid !== undefined) {
          bookingData.booking_link_uuid = this.conferenceState.uuid;
        }

        bookingItems.push(bookingData);
      }
    }

    return bookingItems;
  }

  doBooking(): void {
    this.disableBookingButton = true;
    this.bookButtonLoader = true;
    this.bookingErrorMessage = undefined;

    // Normal flow (non-Stripe): prepare bookingItems and proceed directly
    const bookingItems = this.prepareBookingItems();
    this.processBooking(bookingItems);
  }

  private processBooking(bookingItems: AppointmentBookItem[]): void {
    if (this.isBookingDisabled) {
      LoggerService.error(bookingItems);
      this.disableBookingButton = false;
      this.bookButtonLoader = false;
      this.showStripeRedirectionLoader = false;
      return;
    }

    this.adyenResumeService.markBookingSent(this.partner?.id, this.adyenPaymentDetails?.session_id);

    this.bookingRequestInFlight = true;
    this.formService
      .bookAppointments(bookingItems)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.bookingRequestInFlight = false)
      )
      .subscribe({
        next: (result: {
          success?: boolean;
          errors?: { message: string }[];
          bookingErrors?: { code: number; message: string }[],
          appointments?: any[];
        }) => {
          this.adyenResumeService.releaseIfBookingSent(this.partner?.id);
          if (result.success) {
            this.showStripeRedirectionLoader = false;
            this.brokerState = {};

            if (result?.appointments?.length > 0) {
              for (const item of result?.appointments) {
                this.successFullBookings.push({
                  landingPageLink:
                    environment?.calioDashboardBaseUrl +
                    '/appointments/' +
                    item?.uuid,
                  bookingUUID: item?.uuid,
                  selectedStore: item?.store ?? item?.worker?.store,
                });
              }
            }

            // send booking success to event to parent window
            this.googleAnalyticsService.emitEventToParent(WINDOW_LISTENER_CONSTANTS.APPOINTMENT_BOOKING_DONE, result?.appointments);
            this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.APPOINTMENT_BOOKING_STEP_SUCCESS);
            this.googleAnalyticsService.generateSessionUuid();

            if (this.globals.isInternal === false) {
              this.utilService.updateLocalStorage(this.CUSTOMFIELDS_LS_NAME, this.customFieldValues);
              this.userState.meeting_type_id = undefined;
              this.userState.captcha_challenge = undefined;
              // A zip this widget filled from the store search belongs to the booking just made, so it is
              // not kept for the next one. A zip the customer entered is kept.
              this.userState.zip = resolvePersonalFormZip({
                currentZip: this.userState.zip,
                explicitCustomerZip: undefined,
                storePostcode: null,
                filledFromPostcode: this.widgetUtilService.zipFilledFromStorePostcode,
              }).zip;
              this.utilService.updateLocalStorage(this.USER_LS_NAME, Object.assign({}, this.userState));
              if (this.partner.is_customer_profiles_feature_enabled === 1 && this.brokerState) {
                this.brokerState.meeting_type_id = undefined;
              }
            } else {
              this.userState = { timezone: this.userState.timezone };
              this.customFieldValues = {};
              this.selectedJsonCustomerDetail = undefined;
              this.localStorageService.removeItem(this.CUSTOMFIELDS_LS_NAME, () => void 0);
              this.localStorageService.removeItem(this.USER_LS_NAME, () => void 0);
            }

            this.setInitInternalComment();
            this.bookingSuccessEvent.emit();

            // Reset personalFormValid status
            this.formService.personalFormValid = false;

            this.finalPage = true;

            // clear cart from ls and object
            this.localStorageService.removeItem(this.STATE_LS_NAME, () => void 0);
            this.localStorageService.removeItem(this.CART_LS_NAME, () => void 0);

            this.appointmentState = {
              store: null,
              services: [],
              relatedServices: [],
              worker: null,
              date: null,
              termins: null,
              day: null,
              leadGeneratorPostcode: null,
            };
            this.widgetUtilService.resetStoreSearchZipCode();

            // update isCombiServiceSelected status according to the selected services
            this.updateIsCombiServiceSelectedStatus();

            this.calendarSlotsCountList = [];
          } else {
            // Redirect to final page with error message
            this.finalPage = false;
          }
          this.priceAfterCouponReduction = undefined;
          this.cartVat.set({ byRate: [], totalCents: 0 });
          this.stripePaymentMethodId = undefined;
          this.paypalOrderDetail = undefined;
          this.saferPayPaymentDetails = undefined;
          // The Adyen session is spent too: the shopper has already been charged and the backend now refuses to claim a log that produced a booking, so re-sending it would only fail.
          this.adyenPaymentDetails = undefined;
          this.storageComplete = false;
          this.booked = true;
          this.disableBookingButton = false;
          this.isInvalidCoupon = false;
          this.bookButtonLoader = false;
          this.appointmentService.gtmStartTriggered = false;
          this.showStripeRedirectionLoader = false;
          if (this.partnerService.hasFeature('is_external_success_page_forwarding_enabled')) {
            if (
              this.partner.is_redirect_after_booking_enabled &&
              this.partner.successful_booking_redirect_url &&
              this.partner.redirect_after_booking_action === this.bookingRedirectionViews.BOOKING_SUMMARY_VIEW &&
              !this.globals.isInternal
            ) {
              this.helperService.redirectToUrl(this.partner.successful_booking_redirect_url);
            }
          }
          this.localStorageService.setItem(LOCAL_STORAGE_CONSTANTS.LAST_PAYMENT_METHOD, this.paymentType, () => {
            LoggerService.log('LAST_PAYMENT_METHOD saved', this.paymentType);
          });
        },
        error: error => {
          // A paid booking still held by the booking lock after every resend is most likely being
          // completed: keep this tab's record that /book was sent, so a reload cannot start a
          // second payment beside it.
          const stillCompleting = isPaidBookingStillCompleting(error, !!this.adyenPaymentDetails);
          if (!stillCompleting) {
            this.adyenResumeService.releaseIfBookingSent(this.partner?.id);
          }
          LoggerService.error(error);
          this.isPaymentInProgress = false;
          this.showFullscreenOverlay = false;
          this.showRefundNotice = !!(this.stripePaymentMethodId || this.paypalOrderDetail || this.saferPayPaymentDetails || this.adyenPaymentDetails);
          // A lost answer is not a refusal: the booking may exist, so no refund is promised.
          this.refundNoticeKey = refundNoticeKeyFor(error, !!this.adyenPaymentDetails);
          this.refundTransactionId = this.stripePaymentMethodId
            || this.paypalOrderDetail?.paypal_order_id
            || this.saferPayPaymentDetails?.transaction_id
            || this.adyenPaymentDetails?.session_id;
          // After /book fails the payment tokens are dead — Stripe PI is already
          // captured (refunded async by BE cron), PayPal order is consumed, Saferpay
          // auth will expire. Invalidate locally and ask the Stripe component to
          // create a fresh PI so the next click can't reuse a dead token.
          const stripeWasUsed = !!this.stripePaymentMethodId;
          const adyenWasUsed = !!this.adyenPaymentDetails;
          const paypalOrSaferpayWasUsed = !!(this.paypalOrderDetail || this.saferPayPaymentDetails);
          // A paid booking whose answer was lost (connection dropped, 504) may have gone through.
          const outcomeUnknown = (paypalOrSaferpayWasUsed || adyenWasUsed) && isBookingOutcomeUnknown(error);
          // The backend will not claim this payment session again - which does not prove a booking.
          const sessionSpent = isPaymentSessionSpent(error);
          // The backend says this payment already backs a confirmed booking: that booking exists.
          const alreadyBooked = isAlreadyBookedWithPayment(error);
          this.stripePaymentMethodId = undefined;
          this.paypalOrderDetail = undefined;
          this.saferPayPaymentDetails = undefined;
          // The Adyen session is spent too: the shopper has already been charged and the backend now refuses to claim a log that produced a booking, so re-sending it would only fail.
          this.adyenPaymentDetails = undefined;
          // Reset so the next storeBookingItemsEvent goes false -> true and the
          // Stripe component's @Input setter actually fires handlePayment().
          // Without this, the second Book click updates the PI but never calls
          // confirmPayment() and the loader hangs.
          this.storageComplete = false;
          if (stripeWasUsed) {
            this.paymentService.recreatePaymentIntentSubject.next();
          }
          if (stillCompleting) {
            // Check the email, and NO "Pay again": the booking is most likely going through.
            this.paymentService.bookingStillCompletingSubject.next();
          } else if (alreadyBooked) {
            // The booking exists: its notice, the payment form kept down and NO "Pay again".
            this.paymentService.paymentAlreadyBookedSubject.next();
          } else if (sessionSpent) {
            // Handled like a lost answer, in its own words: check the email, then "Pay again".
            this.paymentService.paymentSessionSpentSubject.next();
          } else if (outcomeUnknown) {
            // The booking may exist, so the payment form must NOT come back on its own: that invited
            // a second payment beside a "check your email" notice. The customer re-arms it with
            // "Pay again" once they have checked.
            this.paymentService.bookingOutcomeUnknownSubject.next();
          } else if (paypalOrSaferpayWasUsed || adyenWasUsed) {
            // Brings the PayPal button / Saferpay launcher / Adyen Drop-in back into the DOM
            // so the customer can authorize a fresh payment for the retry. For Adyen this is
            // the ONLY route: a successful payment hides the payment options, which destroys
            // cw-adyen, so nothing is left to signal. Re-rendering it mints a fresh session.
            this.paymentService.resetPaymentSuccessStateSubject.next();
          }

          if (outcomeUnknown || sessionSpent || stillCompleting || alreadyBooked) {
            // Stay on the payment step, where cw-payment-methods says the booking could not be
            // confirmed and offers "Pay again". The final page's "could not be booked, please try
            // again" is exactly the wrong advice for a booking that may exist.
            this.bookingErrorMessage = undefined;
            this.disableBookingButton = false;
            this.bookButtonLoader = false;
            this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.APPOINTMENT_BOOKING_STEP_FAILED);
            return;
          }
          if (this.showStripeRedirectionLoader) {
            this.showStripeRedirectionLoader = false;
            this.finalPage = false;
            this.booked = false;
            this.disableBookingButton = false;
            this.bookButtonLoader = false;
            this.viewMode = this.partner?.split_personal_form_and_summary_in_widget === 1 ? APPOINTMENT_CONSTANT.SUMMARY : APPOINTMENT_CONSTANT.PERSONAL_INFO;
            if (this.viewMode === APPOINTMENT_CONSTANT.SUMMARY) {
              this.verifyOnlinePaymentStatus();
            }
            LoggerService.error('error?.error?.errors?.[0]?.message', error?.error?.errors?.[0]?.message);
            this.navigateTo(this.viewMode);
            this.bookingErrorMessage = error?.error?.errors?.[0]?.message;

            // Persist cart to localStorage so user can retry after failed redirect payment
            this.utilService.updateLocalStorage(this.CART_LS_NAME, this.cart);
            this.utilService.updateLocalStorage(this.STATE_LS_NAME, this.appointmentState);

            // Wait for the alert to be rendered before scrolling
            setTimeout(() => {
              const element = getDomRoot(this.elementRef.nativeElement).getElementById('booking-error-message');
              element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 1000);
            return;
          }
          if (error?.status === HttpStatusCode.InternalServerError) {
            this.translateService
              .get('common.noDateError')
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe({
                next: (translation) => {
                  this.finalPageError = translation;
                  this.finalPage = false;
                  this.booked = true;
                  this.disableBookingButton = false;
                  this.bookButtonLoader = false;
                }
              });
          } else {
            if (error?.error?.errors?.[0]?.message) {
              // A keyed Adyen refusal in the customer's language; anything else as the backend put it.
              const adyenMessageKey = adyenErrorMessageKey(error);
              this.bookingErrorMessage = adyenMessageKey
                ? this.translateService.instant(adyenMessageKey)
                : error.error.errors[0].message;
              this.disableBookingButton = false;
              this.bookButtonLoader = false;
              return;
            } else if (error?.error?.bookingErrors?.[0]?.message) {
              this.finalPage = false;
              this.bookingErrorMessage = error.error.bookingErrors.map(error => error.message);
            }
            this.finalPageError = error?.message;
            this.finalPage = false;
            this.booked = true;
            this.disableBookingButton = false;
            this.bookButtonLoader = false;
          }

          this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.APPOINTMENT_BOOKING_STEP_FAILED);
          this.priceAfterCouponReduction = undefined;
          this.cartVat.set({ byRate: [], totalCents: 0 });
          this.isInvalidCoupon = false;
        }
      });
  }

  // Change view and update local storage
  navigateTo(target: string, isFirstTime?: boolean): void {
    if (this.adyenPaymentInFlight()) {
      // Leaving the payment step would tear down the payment the shopper may be completing right
      // now. Its own "Cancel payment" is the way out.
      return;
    }

    // Clear the date-step error so re-entering never shows a stale alert
    this.showDateStepValidationError.set(false);

    // Tour flow: store + service are already resolved from /prepare. Any navigation
    // back to the services step means the user wants to return to the tour factory.
    if (target === APPOINTMENT_CONSTANT.APPOINTMENT && this.enteredAppointmentFromTour) {
      // User backed out of the appointment flow — preserve their tour selection.
      this.clearCartForTourBack();
      this.backToTourEvent.emit({ resetSelection: false });
      return;
    }

    if (
      !isFirstTime &&
      this.appointmentsSectionRef
    ) {
      this.appointmentsSectionRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
      });
    }

    this.coupon = undefined;
    this.finalCouponDiscount = 0;
    this.automaticBookableDateProcessIsEnabled = false;
    this.showBookableDateNotAvailableIssue = false;
    this.automationBookingDatesLimitReached = false;

    const materialChangeSteps = [
      APPOINTMENT_CONSTANT.CUSTOMER_TYPE, APPOINTMENT_CONSTANT.APPOINTMENT,
      APPOINTMENT_CONSTANT.DATE, APPOINTMENT_CONSTANT.WORKER,
    ];
    if (materialChangeSteps.includes(target)) {
      this.paypalOrderDetail = undefined;
      this.saferPayPaymentDetails = undefined;
      // The Adyen session is spent too: the shopper has already been charged and the backend now refuses to claim a log that produced a booking, so re-sending it would only fail.
      this.adyenPaymentDetails = undefined;
      this.stripePaymentMethodId = undefined;
      this.refundTransactionId = undefined;
      this.isPaymentInProgress = false;
      this.showRefundNotice = false;
    }

    if (target !== APPOINTMENT_CONSTANT.DATE) {
      this.calendarLoaded = false;
      // Special case when the widget is prefilled up to the date selection step and is also enabled with qualification-based questions.
      // Don't refresh calendar when navigating to PERSONAL_INFO or SUMMARY as it can trigger dayClicked and clear cart
      const skipCalendarRefresh = target === APPOINTMENT_CONSTANT.PERSONAL_INFO || target === APPOINTMENT_CONSTANT.SUMMARY;
      if (!skipCalendarRefresh && Object.keys(this.availableSlotsArray)?.length > 0) {
        this.customEventService.refreshCalendarEvent.emit();
      }
    }

    // trigger start event on first user interaction
    this.appointmentService.triggerAppointmentStartEvent();

    if (!this.isUserMadeFirstInteraction) {
      this.isUserMadeFirstInteraction = true;

      if (this.partner?.is_customer_profiles_feature_enabled !== 1) {
        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_STORES_AND_SERVICES,
          this.prepareAnalyticsPayload()
        );
      } else {
        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_PROFILES,
          this.prepareAnalyticsPayload()
        );
      }
    }

    switch (target) {
      case APPOINTMENT_CONSTANT.CUSTOMER_TYPE:
        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_PROFILES,
          this.prepareAnalyticsPayload()
        );
        break;

      case APPOINTMENT_CONSTANT.APPOINTMENT:
        if (this.viewMode !== APPOINTMENT_CONSTANT.APPOINTMENT && this.hasQualificationQuestions) {
          this.appointmentService.resetMappedServiceIds();
          this.hasQualificationQuestionsAnswered = false;
        }

        if (this.stores?.length === 0) {
          this.fetchAvailableStores();
        }
        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_STORES_AND_SERVICES,
          this.prepareAnalyticsPayload()
        );
        break;

      case APPOINTMENT_CONSTANT.WORKER:
        // To reset view of date step ghost element must be set to 0
        if (this.viewMode === APPOINTMENT_CONSTANT.DATE) {
          this.showAppointmentSlotGhostElement = 0;
        }

        if (this.viewMode === APPOINTMENT_CONSTANT.DATE && this.appointmentState?.has_meeting_types_restrictions) {
          if (this.backButtonClicked) {
            this.navigateTo(APPOINTMENT_CONSTANT.MEETING_PROVIDERS, isFirstTime);
            return;
          }
        }

        // In case of conference or combi service, skip worker selection and move to appointment step
        if (this.conferenceState?.uuid || this.appointmentState.isCombiServiceSelected) {
          this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT, isFirstTime);
          return;
        }

        // In case is_widget_postcode_worker_random_selection_enabled setting is enabled then worker selection
        // will be either based on default worker or random base so worker step will always skipped and never show
        if (
          Number(this.widgetUtilService.widgetConf.is_widget_postcode_worker_random_selection_enabled) === 1 &&
          this.viewMode === APPOINTMENT_CONSTANT.DATE
        ) {
          this.navigateTo(APPOINTMENT_CONSTANT.APPOINTMENT, isFirstTime);
          return;
        }

        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_RESOURCES,
          this.prepareAnalyticsPayload()
        );
        if (Number(this.partner.is_round_robin_feature_enabled) === 1) {
          LoggerService.warn('[Debug] Going to the date according to round robin screen 0');
          if (this.workersAvailable.length > 0) {
            const worker: any = this.helperService.get_random(
              this.workersAvailable
            );
            this.selectWorker(worker.id);
          } else {
            LoggerService.warn('[Debug] Workers are not available in the round robin approach thats why selecting any worker.');
            this.selectWorker(0);
          }
          this.continueFromSkippedWorkerStep(isFirstTime);
          return;
        }

        if (Number(this.partner.widget_hide_resource_step_for_default_workers) === 1 && this.appointmentState.default_worker_id) {
          this.selectWorker(this.appointmentState.default_worker_id);
          this.continueFromSkippedWorkerStep(isFirstTime);
          return;
        }

        if (this.selectedWorkerId || Number(this.selectedWorkerId) === 0) {
          this.preselectWorker();
          return;
        }

        if (Number(this.partner.hide_resource_step) === 1) {
          this.appointmentState.worker = 0;
          this.onWorkerSelected();
          this.continueFromSkippedWorkerStep(isFirstTime);
          return;
        }

        if (
          this.workersAvailable.length < 2 &&
          this.appointmentState.services.length > 0
        ) {
          if (this.viewMode === APPOINTMENT_CONSTANT.APPOINTMENT) {
            if (this.appointmentState.has_meeting_types_restrictions) {
              target = APPOINTMENT_CONSTANT.MEETING_PROVIDERS;
            } else {
              target = APPOINTMENT_CONSTANT.DATE;
            }
            this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.APPOINTMENT_BOOKING_STEP_AVAILABLE_APPOINTMENTS, this.prepareAnalyticsPayload());
          } else {
            target = APPOINTMENT_CONSTANT.APPOINTMENT;
            this.googleAnalyticsService.emitBookingEvent(GTM_EVENTS.APPOINTMENT_BOOKING_STEP_STORES_AND_SERVICES, this.prepareAnalyticsPayload());
          }
        }
        if (!isFirstTime) {
          this.scrollToAppointmentComponent();
        }
        break;

      case APPOINTMENT_CONSTANT.DATE:
        // not possible if worker or service not selected
        this.googleAnalyticsService.emitBookingEvent(
          GTM_EVENTS.APPOINTMENT_BOOKING_STEP_AVAILABLE_APPOINTMENTS,
          this.prepareAnalyticsPayload()
        );
        this.freeAppointmentsCount = 0;
        if (Number(this.partner.hide_back_on_bookingsite) === 1) {
          this.appointmentService.disableFirstTwoButtonsEvent.emit();
          this.disableDatePagePreviousButton = true;
        }

        if (
          !this.appointmentState.isCombiServiceSelected &&
          this.conferenceState?.uuid === undefined &&
          this.appointmentState.worker == null ||
          this.appointmentState.services.length === 0 ||
          (this.appointmentState.has_meeting_types_restrictions === true && this.appointmentState.meeting_type_id == null)
        ) {
          return;
        }

        this.monthChanged = false;
        this.scrollToAppointmentComponent();
        break;

      case APPOINTMENT_CONSTANT.PERSONAL_INFO:
        this.updateAppointmentCustomFields();
        this.scrollToAppointmentComponent();
        this.resetDataBeforeLoadingSummaryPage();
        this.verifyOnlinePaymentStatus();
        this.bookingErrorMessage = undefined;

        const gtmEventName = Number(this.partner?.split_personal_form_and_summary_in_widget) === 1
          ? GTM_EVENTS.APPOINTMENT_BOOKING_STEP_PERSONAL_INFO
          : GTM_EVENTS.APPOINTMENT_BOOKING_STEP_SUMMARY;

        this.googleAnalyticsService.emitBookingEvent(gtmEventName, this.prepareAnalyticsPayload());
        break;

      case APPOINTMENT_CONSTANT.SUMMARY:
        // Setting personalFormValid flag
        this.formService.personalFormValid = true;
        this.bookingErrorMessage = undefined;

        this.showSummaryDetails = false;
        this.summaryDetails = {
          title: this.userState.title || undefined,
          prename: this.userState.forename || undefined,
          gender: this.userState.gender || undefined,
          lastname: this.userState.lastName || undefined,
          email: this.userState.eMail || undefined,
          phone: this.userState.phone || undefined,
          mobile: this.userState.mobile || undefined,
          birthday: this.userState.birthday || undefined,
          comment: this.userState.comment || undefined,
          company_name: (this.userState?.company || undefined),
          country: (this.userState?.country || undefined),
          internal_comment: (this.userState?.internal_comment || undefined),
          ...(this.partner?.show_address_on_widget !== 0 ? {
            street: this.userState.street,
            zip: this.userState.zip,
            city: this.userState.city
          } : {}),
          customFieldValues: {}
        };

        // Generate options and values to display
        this.getCustomerCustomFieldSelectValue();

        // Get cross selling services
        if (Number(this.partner.show_cross_selling_services_on_summary_step) === 1) {
          this.getCrossSellingServicesByCategory();
        }
        break;
    }

    // Manage current and previous page state
    this.customEventService.currentPage = target;
    this.customEventService.previousPage = this.viewMode;

    this.viewMode = target;
    this.formReseted = false;
    this.utilService.updateLocalStorage(this.STATE_LS_NAME, this.appointmentState);
    this.backButtonClicked = false;
  }

  private getCrossSellingServicesByCategory(): void {
    const servicesCategoryWise = structuredClone(this.appointmentServicesByCat);
    const cartServiceCategoryIds = Array<number>();
    const cartServiceServiceIds = Array<number>();

    this.cart.forEach(cartItem => {
      cartItem.referenceServices.forEach(service => {
        cartServiceCategoryIds.push(service.serviceCategoryId);
        cartServiceServiceIds.push(service.serviceId);
      });
    });

    // mode: 0 = same category (default), 1 = other categories, 2 = all (no category filter)
    const mode = Number(this.partner.cross_selling_services_category_filter ?? 0);
    let candidates = servicesCategoryWise;
    if (mode === 0) {
      candidates = servicesCategoryWise.filter(category =>
        cartServiceCategoryIds.includes(category.appointmentServiceCategory.id)
      );
    } else if (mode === 1) {
      candidates = servicesCategoryWise.filter(category =>
        !cartServiceCategoryIds.includes(category.appointmentServiceCategory.id)
      );
    }

    candidates.forEach(category => {
      category.aServicesOfCat = category.aServicesOfCat.filter(service => !cartServiceServiceIds.includes(service.id));
    });

    this.crossSellingServices = candidates.filter(category => category.aServicesOfCat.length);
  }

  protected onDateNextButtonClick(): void {
    if (Number(this.partner?.widget_buttons_always_enabled) === 1 && this.cart.length <= 0) {
      this.showDateStepValidationError.set(true);
      return;
    }
    this.showDateStepValidationError.set(false);
    this.reserveAppointments();
  }

  private reserveAppointments(redirect = true): void {
    this.slotAlreadyReservedByOtherError = false;

    if (Number(this.partner.is_appointment_reservation_enabled) === 1) {
      this.reservingAppointment = true;
      const appointments: AppointmentReservationBody[] = [];

      if (this.conferenceState?.uuid !== undefined) {
        appointments.push({
          booking_link_uuid: this.conferenceState.uuid,
          start_time: this.cart[0].startTime,
          end_time: this.cart[0].endTime,
        });

        this.cart.forEach(appointment => {
          appointment.reservation_start_time = new Date();
        });
      } else {
        this.cart.forEach(appointment => {
          appointment.servicesIds.forEach(service => {
            const appointmentData: AppointmentReservationBody = {
              appointment_service_id: service,
              worker_id: appointment.workerId,
              start_time: appointment.startTime,
              end_time: appointment.endTime,
              ...this.partner?.is_timezone_enabled && { timezone: this.effectiveDisplayTimezone }
            };

            if (appointment?.relatedAppointmentCardId && appointment?.parentServiceId) {
              appointmentData.related_service_id = appointment?.parentServiceId;
            }

            appointments.push(appointmentData);
          });
          appointment.reservation_start_time = new Date();
        });
      }

      this.formService.reserveAppointments(appointments)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          finalize(() => this.reservingAppointment = false)
        )
        .subscribe({
          next: reservation => {
            if (!reservation?.success && reservation?.preReserved) {
              this.slotAlreadyReservedByOtherError = true;

              reservation.alreadyReserved?.forEach(appointment => {
                const cartAppointment = this.cart.find(cartAppointment =>
                  cartAppointment.startTime === appointment.start_time &&
                  cartAppointment.endTime === appointment.end_time
                );

                if (cartAppointment) {
                  this.cartService.removeFromCart(
                    cartAppointment.cartItemId,
                    this.CART_LS_NAME,
                    this.cart,
                    (cart: CartItem[]) => {
                      this.cart = cart;

                      // Update calendar date badge
                      let calendarSlotsCount = this.calendarSlotsCountList.findIndex(calendarSlot =>
                        cartAppointment.date.toString() === calendarSlot.date.toString()
                      );

                      if (calendarSlotsCount >= 0) {
                        this.calendarSlotsCountList[calendarSlotsCount].slotsCount -= 1;
                        this.calendarSlotsCountList = [...this.calendarSlotsCountList];
                      }
                    }
                  )
                }
              });

              redirect && this.customEventService.refreshCalendarEvent.emit();
            } else {
              redirect && this.navigateTo(this.appointmentConstant.PERSONAL_INFO);
            }
          },
          error: (error: HttpErrorResponse) => {
            LoggerService.error(error);
            LoggerService.warn('[Reservation Failed] Moving to personal info step even slot has been failed to reserve');
            redirect && this.navigateTo(this.appointmentConstant.PERSONAL_INFO);
          }
        });
    } else {
      redirect && this.navigateTo(this.appointmentConstant.PERSONAL_INFO);
    }
  }

  // button event to clear local storage
  resetForm(): void {
    this.localStorageService.clear(() => {
      // Clear form inputs
      this.appointmentState = {
        customerProfileId: this.appointmentState.customerProfileId,
        store: this.appointmentState.store,
        services: [],
        relatedServices: [],
        worker: null,
        date: null,
        termins: null,
        day: null,
        leadGeneratorPostcode: null,
      };

      // update isCombiServiceSelected status according to the selected services
      this.updateIsCombiServiceSelectedStatus();

      this.userState = {
        forename: null,
        lastName: null,
        gender: null,
        eMail: null,
        phone: null,
        mobile: null,
        comment: null,
        customerId: null,
        customerUuid: null,
        street: null,
        zip: null,
        city: null,
        company: null,
        internal_comment: null,
        timezone: this.userState.timezone
      };

      this.brokerState = {
        forename: null,
        lastName: null,
        gender: null,
        eMail: null,
        phone: null,
        mobile: null,
        comment: null,
        customerId: null,
        customerUuid: null,
        street: null,
        zip: null,
        city: null,
        company: null,
        internal_comment: null,
      };

      // Clear cart and custom fields
      this.cart = [];

      // Custom field and Custom field values
      this.customFieldValues = {};
      this.appointmentCustomFields = [];
      this.tempArray = [];

      // Go back to first tab
      this.viewMode = APPOINTMENT_CONSTANT.APPOINTMENT;

      // Show success message
      this.formReseted = true;
      this.calendarSlotsCountList = [];

      this.setInitInternalComment();
    });
  }

  // Check if browser width is mobile size
  @HostListener('window:resize', ['$event'])
  checkIfMobile(event) {
    this.isMobile = this.deviceDetectorService.isMobile();
  }

  // To be used as wrapper for 'do nothing'
  ignore(): boolean {
    return false;
  }

  updateUserState(newUserState: UserState): void {
    this.userState = newUserState;
  }

  updateCustomerSelected(newCustomerSelected: object): void {
    this.customerSelected = newCustomerSelected;
  }

  // just add (click)="showMessage()" where needed
  showMessage(): void {
    this.isClicked = !this.isClicked;
  }

  onWorkerSubmit(workerForm) {
    return workerForm;
  }

  // Check if all prerequisites are good on order to enable book button
  bookValidated(): boolean {
    if (this.cart.length > 0) {
      if (Number(this.partner.is_captcha_feature_enabled) === 1) {
        if (this.partner.captcha_type === CAPTCHA_TYPE.CALENSO_DEFAULT && !this.userState.captcha_challenge) {
          LoggerService.warn('[Validation failed] Calenso DefaultCaptcha is required');
          return false;
        } else if (this.partner.captcha_type === CAPTCHA_TYPE.FRIENDLY && !this.userState.friendly_captcha_challenge) {
          LoggerService.warn('[Validation failed] Friendly Captcha is required');
          return false;
        }
      }

      if (this.globals?.isInternal) {
        // Check if customer is selected
        if (this.customerSelected) {
          return true;
        } else {
          if (this.userState?.forename && this.userState?.lastName) {
            if (this.partner?.needPhoneNumber && this.partner?.widget_phone_required && !this.userState?.phone) {
              LoggerService.warn('[Validation failed] Phone number is required');
              return false;
            }

            if (this.partner?.needMobileNumber && this.partner?.widget_mobile_required && !this.userState?.mobile) {
              LoggerService.warn('[Validation failed] Mobile number is required');
              return false;
            }

            if (this.partner?.internal_widget_email_shown === 1) {
              if (
                this.partner?.internal_widget_email_required === 1 &&
                this.userState.eMail
              ) {
                return true;
              }
            }
            return true;
          }
          return false;
        }
      } else {
        return true;
      }
    } else {
      LoggerService.warn('[Validation failed] Cart is empty');
      return false;
    }
  }

  selectWorker(workerId: number, refreshCalendar = false): void {
    this.appointmentState.worker = Number(workerId);
    this.onWorkerSelected(refreshCalendar);
  }

  disabledServiceTab(isDisabled: boolean): void {
    this.isServicesTabDisabled = isDisabled;
  }

  // A persisted worker outside the active subset must not be restored — the embed
  // config is authoritative over stale local storage.
  private isPersistedWorkerAllowed(workerId: number): boolean {
    if (!this.isWorkerSubsetActive()) {
      return true;
    }
    return Number(workerId) > 0 && this.selectedWorkerIds.includes(Number(workerId));
  }

  setInitStateLSName(): void {
    // Read local storage to set form state
    this.localStorageService.getItem(this.STATE_LS_NAME, (savedFormState) => {
      if (savedFormState) {
        if (savedFormState?.customerProfileId) {
          this.appointmentState.customerProfileId = savedFormState?.customerProfileId;
        }
        if (savedFormState?.store) {
          this.appointmentState.store = savedFormState?.store;
        }
        if (savedFormState?.services) {
          this.appointmentState.services = savedFormState?.services;
        }
        if (savedFormState?.worker && this.isPersistedWorkerAllowed(savedFormState.worker)) {
          this.appointmentState.worker = savedFormState?.worker;
        }
        if (savedFormState?.date) {
          this.appointmentState.date = savedFormState?.date;
        }
        if (savedFormState?.termins) {
          this.appointmentState.termins = savedFormState?.termins;
        }
        if (savedFormState?.day) {
          this.appointmentState.day = savedFormState?.day;
        }
        if (savedFormState?.default_worker_id && this.isPersistedWorkerAllowed(savedFormState.default_worker_id)) {
          this.appointmentState.default_worker_id = savedFormState?.default_worker_id;
        }
        if (savedFormState?.leadGeneratorPostcode) {
          this.appointmentState.leadGeneratorPostcode = savedFormState?.leadGeneratorPostcode;
        }
        if (savedFormState?.default_worker && this.isPersistedWorkerAllowed(savedFormState.default_worker?.id)) {
          this.appointmentState.default_worker = savedFormState?.default_worker;
        }
        if (savedFormState?.storeDefaultWorkerIds) {
          this.appointmentState.storeDefaultWorkerIds = savedFormState?.storeDefaultWorkerIds;
        }

        // If selected date from localstorage is in past ignore it
        if (this.appointmentState.date < this.now) {
          this.appointmentState.date = null;
        }

        if (this.appointmentState.worker != null) {
          this.onWorkerSelected();
        }

        if (this.appointmentState.date) {
          // Set calendar default state to preselected month
          this.viewDate = this.appointmentState.date;
          this.lastCalendarMonth = this.viewDate.getMonth() + 1;

          this.updateCalendarPrevState(this.viewDate);
        }
      }
    });
  }

  verifyOnlinePaymentStatus() {
    this.partnerService.verifyOnlinePaymentStatus().subscribe({
      next: paymentStatus => {
        if (paymentStatus) {
          this.isServiceOnlinePaymentEnabled = Number(paymentStatus.isServiceOnlinePaymentEnabled);
          if (
            paymentStatus.isServiceOnlinePaymentEnabled === 1 &&
            paymentStatus.isStripeAppointmentPaymentEnabled === 1 &&
            paymentStatus.stripeEnabled
          ) {
            this.isStripeEnabled = true;
          }
          if (paymentStatus.isOnlinePaymentMandatory === 1) {
            this.isOnlinePaymentMandatory = true;
          }
          if (paymentStatus.isBexioAppointmentServicePaymentEnabled === 1 && paymentStatus.bexioEnabled) {
            this.isBexioEnabled = true;
          }
          if (paymentStatus.isExternalInvoiceAppointmentPaymentEnabled === 1) {
            this.isExternalInvoiceEnabled = true;
            // The payment card is the only place a type can be chosen, and it renders on
            // isServiceOnlinePaymentEnabled. Without this, a partner offering ONLY invoice
            // (appointment payment off, on-site off) got no card, no payment type, and a Book
            // button that sent nothing. Same move the on-site branch below makes.
            this.isServiceOnlinePaymentEnabled = 1;
          }
          if (paymentStatus.isServiceOnlinePaymentEnabled === 1 && paymentStatus.saferpayEnabled) {
            this.isSaferpayEnabled = true;
          }
          if (paymentStatus.isServiceOnlinePaymentEnabled === 1 && paymentStatus.adyenEnabled) {
            this.isAdyenEnabled = true;
          }
          if (paymentStatus.isServiceOnlinePaymentEnabled === 1 && paymentStatus.paypalEnabled) {
            this.isPaypalEnabled = true;
            this.paypalSetting = new PayPalSettingsDbModel();
            this.paypalSetting.access_token = paymentStatus.paypalAccessToken;
            this.paypalSetting.client_id = paymentStatus.paypalClientId;
          }
          if (paymentStatus.onlinePaymentShowOnSitePaymentType === 1) {
            this.isServiceOnlinePaymentEnabled = 1;
            if (paymentStatus.isOnlinePaymentMandatory !== 1) {
              this.isStoreEnabled = true;
            }
          }
          this.isLexOfficePaymentTypeEnabled = (paymentStatus.lexOfficeEnabled === true);
          this.stripeConnectedAccountId = paymentStatus.stripeConnectedAccountId ?? null;
          this.defaultPaymentType = paymentStatus.defaultPaymentType ?? '';
        }
        this.paymentType = undefined;
      }
    });
  }

  onChangePaymentType(event: string) {
    this.paymentType = event;
    this.stripePaymentMethodId = null;
    this.paypalOrderDetail = undefined;
    this.saferPayPaymentDetails = undefined;
    this.isPaymentInProgress = false;
    this.invoiceAddressChecked = false;
    this.invoiceAddressValid = true;
    this.invoiceAddress = undefined;
    if (event === this.paymentTypes.CREDITCARD && this.isStripeEnabled && (this.priceAfterCouponReduction ?? this.totalCartPrice) > 0) {
      this.disableBookingButton = true;
      this.stripeElementLoading = true;
    } else if (!this.isReservationExpired) {
      this.disableBookingButton = false;
      this.stripeElementLoading = false;
    }
  }

  // Check if all prerequisites are good on order to enable book button
  /**
   * Adyen is selected but not paid yet. The form has already validated by the time the payment
   * gate runs, so this is the moment to charge the card - Drop-in has no button of its own
   * (showPayButton: false), the widget's Book button drives it.
   *
   * Always returns FALSE: this booking attempt stops here either way. On success onAdyenPaid()
   * restarts it with the session in hand. If the card fields are incomplete Drop-in says so
   * itself and the shopper stays on the form, so no payment error is emitted for that case -
   * nothing has failed yet.
   */
  private payWithAdyenThenBook(): boolean {
    // A payment Adyen has already accepted must not be submitted a second time. Nothing else
    // stops it: the Book button is not disabled while the card is authorising (deliberately -
    // an incomplete card submits nothing and never calls back, so disabling on the press left
    // the shopper with a dead button), and an authorisation can stay open for tens of seconds
    // behind a 3DS2 challenge. Without this the shopper can press Book again in that window.
    if (this.adyenPaymentInFlight()) {
      return false;
    }

    const submitted = this.paymentMethodsComponent?.submitAdyen() ?? false;
    this.bookOnceAdyenPaid = submitted;
    // The latch is NOT set from this return value. `submit()` reports true whenever Drop-in did
    // not throw, and on an incomplete card Drop-in throws nothing - it just marks its own fields.
    // Latching here would therefore freeze Book on an attempt that never happened, with no
    // callback coming to release it: a dead button and a half-typed card. onAdyenPaymentStarted()
    // sets it instead, driven by Drop-in's own beforeSubmit, which runs only for a real payment.
    if (!submitted) {
      this.customEventService.paymentGatewayErrorEvent.emit(true);
    }

    return false;
  }

  isPaymentBookButtonValidated(): boolean {
    if (
      this.totalCartPrice === 0 ||
      this.totalCartPrice === -1 ||
      this.priceAfterCouponReduction <= 0
    ) {
      this.paymentType = this.paymentTypes.STORE;
      return true;
    } else {
      if (
        !this.isBexioEnabled &&
        !this.isStripeEnabled &&
        !this.isPaypalEnabled &&
        !this.isSaferpayEnabled &&
        !this.isAdyenEnabled &&
        !this.isLexOfficePaymentTypeEnabled &&
        !this.isExternalInvoiceEnabled
      ) {
        // TODO Add comment online payment is not active
        this.paymentType = this.paymentTypes.STORE;
        return true;
      } else {
        if (this.isOnlinePaymentMandatory) {
          if (
            (this.stripePaymentMethodId && this.paymentType === this.paymentTypes.CREDITCARD) ||
            this.paymentType === this.paymentTypes.INVOICE ||
            this.paymentType === this.paymentTypes.LEX_OFFICE_INVOICE ||
            this.paymentType === this.paymentTypes.EXTERNAL_INVOICE ||
            (this.paypalOrderDetail && this.paymentType === this.paymentTypes.PAYPAL) ||
            (this.saferPayPaymentDetails && this.paymentType === this.paymentTypes.SAFERPAY) ||
            (this.adyenPaymentDetails && this.paymentType === this.paymentTypes.ADYEN)
          ) {
            return true;
          } else if (this.paymentType === this.paymentTypes.ADYEN) {
            return this.payWithAdyenThenBook();
          } else {
            // TODO it should catch not valid stripe credit cards or payment type is store / null
            this.customEventService.paymentGatewayErrorEvent.emit(true);
            return false;
          }
        } else {
          if (this.paymentType === this.paymentTypes.CREDITCARD) {
            if (this.stripePaymentMethodId) {
              return true;
            } else {
              return false;
            }
          } else if (this.paymentType === this.paymentTypes.INVOICE) {
            return true;
          } else if (this.paymentType === this.paymentTypes.STORE) {
            return true;
          } else if (this.paymentType === this.paymentTypes.LEX_OFFICE_INVOICE) {
            return true;
          } else if (this.paymentType === this.paymentTypes.EXTERNAL_INVOICE) {
            return true;
          } else if (this.paymentType === this.paymentTypes.SAFERPAY) {
            if (this.saferPayPaymentDetails) {
              return true;
            } else {
              this.customEventService.paymentGatewayErrorEvent.emit(true);
              return false;
            }
          } else if (this.paymentType === this.paymentTypes.PAYPAL) {
            if (this.paypalOrderDetail) {
              return true;
            } else {
              this.customEventService.paymentGatewayErrorEvent.emit(true);
              return false;
            }
          } else if (this.paymentType === this.paymentTypes.ADYEN) {
            if (this.adyenPaymentDetails) {
              return true;
            } else {
              return this.payWithAdyenThenBook();
            }
          } else {
            this.customEventService.paymentGatewayErrorEvent.emit(true);
            return false;
          }
        }
      }
    }
  }

  submitBooking(): void {
    if (this.adyenPaymentInFlight()) {
      // Book is locked while the payment runs; a successful payment books by itself.
      return;
    }

    if (this.isReservationExpired) {
      this.bookingErrorMessage = this.translateService.instant(reservationExpiredMessageKey(this.isAdyenPaymentHeld()));
      return;
    }

    if (this.formService.imageUploaded === false) {
      LoggerService.warn('[Processing] Image is uploading...');
      this.markFormGroupTouched(this.appointmentForm);
      return;
    }

    if (this.appointmentForm.invalid) {
      this.handlePersonalFormInvalidState();
      return;
    }

    // When a 100% coupon reduces the price to 0, switch to STORE payment
    // to avoid triggering Stripe when the payment element is hidden.
    if (this.totalCartPrice <= 0 || this.priceAfterCouponReduction <= 0) {
      this.paymentType = this.paymentTypes.STORE;
    }

    if (this.paymentType === this.paymentTypes.SAFERPAY) {
      this.payUsingSaferpay();
    } else if (this.paymentType === this.paymentTypes.CREDITCARD) {
      this.payUsingStripe();
    } else {
      this.book();
    }
  }

  onStripeSuccessfulEvent(method: string) {
    this.stripePaymentMethodId = method;
    this.book();
  }

  onResetStripeTokenEvent(errorMessage: string) {
    this.bookingErrorMessage = errorMessage;
    this.helperService.bookingLoader.emit(false);
    if (!this.isReservationExpired) {
      this.disableBookingButton = false;
    }
    this.stripeElementLoading = false;
    this.bookButtonLoader = false;
    this.stripePaymentMethodId = null;
    this.storageComplete = false;
  }

  onStripElementLoadEvent(isStripeLoaded: boolean) {
    // Loaded or failed, the loading gate must release — a failed load surfaces its
    // error through resetStripeTokenEvent and must not leave the button dead.
    this.stripeElementLoading = false;
    if (!this.isReservationExpired) {
      this.disableBookingButton = false;
    }
  }

  onReservationExpired(expired: boolean): void {
    const wasExpired = this.isReservationExpired;
    this.isReservationExpired = expired;
    if (expired) {
      this.disableBookingButton = true;
      if (this.bookingRequestInFlight) {
        // A /book is already on its way - a paid one may be waiting out the booking lock - and it may
        // well book. Its answer decides what the shopper is told: no "nothing was booked, refunded"
        // beside it.
        return;
      }
      // With a payment held for this booking, going back would drop it: say that it is refunded.
      this.bookingErrorMessage = this.translateService.instant(reservationExpiredMessageKey(this.isAdyenPaymentHeld()));
    } else if (wasExpired && !this.bookButtonLoader) {
      // A refreshed reservation lifts the block; only undo what the expiry set,
      // and never while a booking request is still in flight.
      this.disableBookingButton = false;
      this.bookingErrorMessage = undefined;
    }
  }

  onStoreBookingItemsEvent(): void {
    // Prepare and store bookingItems when triggered from Stripe component
    if (this.paymentType === this.paymentTypes.CREDITCARD && !this.stripePaymentMethodId) {
      LoggerService.log('[locale Storage] Storing bookingItems before Stripe verification (triggered from Stripe component)');

      const data = this.buildRedirectionSnapshot();

      this.utilService.updateLocalStorage(APPOINTMENT_CONSTANT.APPOINTMENT_STRIPE_REDIRECTION_DATA_LS_NAME, data);
      this.storageComplete = true;
    }
  }

  /** Puts the booking a payment return parked back in place (Stripe redirect, Adyen resume). */
  private restoreRedirectionSnapshot(data: Record<string, any>): void {
    this.appointmentState = data.appointmentState ?? this.appointmentState;
    this.cart = data.cart ?? this.cart;
    this.customFieldValues = data.customFieldValues ?? this.customFieldValues;
    this.qualificationQuestionsValues = data.qualificationQuestionsValues ?? this.qualificationQuestionsValues;
    this.userState = data.userState ?? this.userState;
    this.totalCartPrice = data.totalCartPrice ?? this.totalCartPrice;
    if (data.cartVat) {
      this.cartVat.set(data.cartVat);
    }
  }

  /** The booking as it stands, for a payment return (Stripe redirect, Adyen resume) to book as is. */
  private buildRedirectionSnapshot(): Record<string, unknown> {
    return {
      bookingItems: this.prepareBookingItems(),
      appointmentState: this.appointmentState,
      cart: this.cart,
      customFieldValues: this.customFieldValues,
      qualificationQuestionsValues: this.qualificationQuestionsValues,
      userState: this.userState,
      totalCartPrice: this.totalCartPrice,
      cartVat: this.cartVat(),
    };
  }

  /**
   * The shopper comes back from a page an Adyen payment had to leave for (a 3DS redirect, or the
   * hosted page in this tab). Restores the booking exactly as it was parked, lets AdyenResumeService
   * finish the payment, and books once -
   * the same stored booking a Stripe redirect return books, with the Adyen handles in place of the
   * payment intent. `/book` still verifies the payment with Adyen itself.
   */
  private resumeAdyenPayment(resume: AdyenResumeReturn): void {
    const data = resume.record.snapshot.data as Record<string, any>;
    if (!Array.isArray(data?.bookingItems)) {
      this.adyenResumeService.clear(resume.record.partnerId);
      return;
    }
    this.restoreRedirectionSnapshot(data);
    this.disableBookingButton = true;
    this.bookButtonLoader = true;
    this.bookingErrorMessage = undefined;
    this.showStripeRedirectionLoader = true;
    this.paymentType = this.paymentTypes.ADYEN;

    this.adyenResumeService.complete(resume, {
      holdScope: buildAdyenHoldScope({
        widgetType: this.widgetConstant.APPOINTMENT,
        cart: this.cart,
        storeId: this.appointmentState?.store,
        bookingLinkUuid: this.conferenceState?.uuid,
        isCombiServiceSelected: this.appointmentState?.isCombiServiceSelected,
      }),
      items: this.cart?.length ?? 0,
    }).then(details => {
      this.adyenPaymentDetails = details;
      this.processBooking((data.bookingItems as AppointmentBookItem[]).map(item => (
        item.payment_type === this.paymentTypes.ADYEN
          ? { ...item, adyen_session_id: details.session_id, adyen_session_result: details.session_result }
          : item
      )));
    }, (failure: AdyenResumeFailure) => {
      // The booking stays restored on the payment step; paying again mints a fresh session unless
      // the payment is held (Pending), which cw-adyen then says itself.
      this.showStripeRedirectionLoader = false;
      this.disableBookingButton = false;
      this.bookButtonLoader = false;
      this.bookingErrorMessage = failure?.silent
        ? undefined
        : this.translateService.instant(failure?.messageKey ?? 'adyen.errors.unexpected');
    });
  }

  onPaypalSuccessfulEvent(event: PayPalOrderDetailModel) {
    this.paypalOrderDetail = event;
    this.book();
  }

  onResetPaypalEvent(event: any): void {
    this.paypalOrderDetail = null;
    this.isPaymentInProgress = false;
  }

  onCancelPayment(): void {
    this.paypalOrderDetail = undefined;
    this.isPaymentInProgress = false;
    // Re-init PayPal SDK so the button is freshly usable after cancel
    this.customEventService.resetPayPalOrderDetailEvent.emit();
  }

  onSaferpaySuccessfulEvent(paymentDetails: SaferPayPaymentDetailsDbModel) {
    this.saferPayPaymentDetails = paymentDetails;
    this.showFullscreenOverlay = false;
    this.book();
  }

  onResetSaferpayEvent(errorMessage: string): void {
    this.bookingErrorMessage = errorMessage;
    this.disableBookingButton = false;
    this.bookButtonLoader = false;
    this.saferPayPaymentDetails = undefined;
    this.showFullscreenOverlay = false;
  }

  hideBookingAgainButton(): boolean {
    if (this.finalPage) {
      if (this.partner.hide_book_additional_appointment_button === 1) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  onCouponSuccessEvent(event: CouponDbModel): void {
    this.coupon = event;
    this.couponDisableConfirmButton = false;
    this.isInvalidCoupon = false;
    this.calculateCoupon();
    // A price of 0 unmounts the Stripe element before it can report ready, so the
    // loading gate must be released here or the book button stays disabled forever.
    if (this.priceAfterCouponReduction <= 0) {
      this.disableBookingButton = false;
      this.stripeElementLoading = false;
    }
    this.paypalOrderDetail = undefined;
    this.customEventService.couponChangeEvent.emit(this.finalCouponDiscount);
  }

  calculateCoupon(): void {
    if (this.coupon && this.coupon.is_fixed_amount === 1) {
      this.finalCouponDiscount = Number(this.coupon.fixed_amount);
    }

    if (this.coupon && this.coupon.is_percentage === 1) {
      this.finalCouponDiscount = Number(((Number(this.totalCartPrice) / 100) * this.coupon.percentage).toFixed(2));
    }

    const netAfterCoupon = Number(this.totalCartPrice) - Number(this.finalCouponDiscount);
    const vat = this.calculateCartVat(netAfterCoupon);
    this.cartVat.set(vat);
    // priceAfterCouponReduction carries the GROSS amount — it is what cw-payment-methods and the
    // Stripe PaymentIntent use as the amount to charge.
    this.priceAfterCouponReduction = Number((netAfterCoupon + vat.totalCents / 100).toFixed(2));
  }

  // Summed in whole cents: 100.10 + 7.60 in floating point is 107.69999999999999, which a
  // payment provider that truncates would charge as 107.69.
  protected cartTotalInclVat(): number {
    if (!(Number(this.totalCartPrice) > 0)) {
      return this.totalCartPrice;
    }
    return (Math.round(Number(this.totalCartPrice) * 100) + this.cartVat().totalCents) / 100;
  }

  /** Net-after-coupon → VAT (empty/zero for `inclusive` partners — see D1 in the plan). */
  private calculateCartVat(discountedNet: number): VatResult {
    if (!isVatAddedOnTop(this.partner?.widget_vat_type)) {
      return { byRate: [], totalCents: 0 };
    }
    const discountedNetCents = Math.round(discountedNet * 100);
    const undiscountedNetCents = Math.round(Number(this.totalCartPrice) * 100);
    return calculateVat(this.cartService.totalCartTaxableLines, discountedNetCents, undiscountedNetCents);
  }

  /**
   * Standalone "Invoice" payment mode: keeps the booking button disabled while the
   * "different address" checkbox is checked but the invoice-address form is incomplete.
   */
  protected readonly isInvoiceAddressMandatory = isInvoiceAddressMandatoryFor;

  onInvoiceAddressChangeEvent(event: { checked: boolean; valid: boolean; value: AppointmentBookItem['invoice_address'] | null }): void {
    this.invoiceAddressChecked = event.checked;
    this.invoiceAddressValid = event.valid;
    this.invoiceAddress = event.value ?? undefined;
  }

  get isInvoiceAddressFormBlockingBooking(): boolean {
    return this.invoiceAddressChecked && !this.invoiceAddressValid;
  }

  onCouponFailedEvent(event: {
    disableBookingButton: boolean;
    invalidCoupon: boolean;
  }) {
    this.coupon = undefined;
    this.finalCouponDiscount = 0;
    this.priceAfterCouponReduction = undefined;
    this.couponDisableConfirmButton = event.disableBookingButton;
    this.isInvalidCoupon = event.invalidCoupon;
    this.calculateCoupon();
    this.paypalOrderDetail = undefined;
  }

  getWidgetAppointmentGroups(store_id: number): void {
    this.formService.getStoreWiseWidgetAppointmentGroups(store_id).subscribe({
      next: (result: WidgetAppointmentGroupModel[] | { errors: any }) => {
        let widgetGroups: WidgetAppointmentGroupModel[] = [];

        if (!result || (<{ errors: any }>result).errors) {
          widgetGroups = [];
          this.widgetGroups = [];
          return;
        }

        widgetGroups = <WidgetAppointmentGroupModel[]>result;

        for (const widgetGroup of widgetGroups) {
          widgetGroup.startHour = parseInt(
            (<string>widgetGroup['start']).split('T')[1].split(':')[0],
            10
          );
        }

        widgetGroups = widgetGroups.sort((a, b) => {
          return a.startHour - b.startHour;
        });

        this.widgetGroups = widgetGroups;
      },
      error: (error: HttpErrorResponse) => {
        LoggerService.error(error);
      }
    });
  }

  configureCustomerLinkEventHandler() {
    if (
      this.appointmentState.leadGeneratorPostcode &&
      this.appointmentState.default_worker_id &&
      this.appointmentState?.default_worker?.is_lead_generator === 1
    ) {
      this.openCreateCustomerLink({
        postcode: this.appointmentState.leadGeneratorPostcode,
        workerId: this.appointmentState.default_worker_id,
      });
    } else {
      this.configureWorkerAndOpenCreateCustomerLink();
    }
  }

  openCreateCustomerLink(data: { postcode: string; workerId: number }) {
    if (data.postcode && data.workerId) {
      let url: string = String(
        `${environment.calioDashboardBaseUrl}/app/customers/create?zip=${data.postcode}`
      );
      url = url + `&worker=${data.workerId}&customer_type=lead`;
      url = url + `&fields=prename,lastname,language,street,zip,city,country,email,mobile,notification_type,customer_type`;
      url = url + `&mandatory=prename,lastname,street,zip,city,mobile,email`;
      window.parent.location.href = url;
    } else {
      LoggerService.warn('CALENSO_WIDGET_WARN: Postcode and worker is mandatory');
    }
  }

  configureWorkerAndOpenCreateCustomerLink() {
    const body: {
      is_lead_generator?: {
        value: string;
        operator: string;
      };
    } = {
      is_lead_generator: {
        value: '1',
        operator: '=',
      },
    };
    this.formService.filterWorkers(body).subscribe({
      next: (result: UserDao[]) => {
        if (result && result.length > 0) {
          this.openCreateCustomerLink({
            postcode: this.appointmentState.leadGeneratorPostcode,
            workerId: result[0].id,
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        LoggerService.error(error);
      }
    });
  }

  private markFormGroupTouched(form: NgForm) {
    Object.values(form.controls).forEach((control) => {
      control.markAsTouched();
    });
  }

  // make intersection of all available workers based on selected services
  private updateAvailableWorkers(): void {
    this.keepWorkerId = 0;
    this.workersAvailable = [];
    if (this.appointmentState.services.length > 0) {
      // Initialize it to first
      let wIntersection = this.workersIdsPerService.get(
        this.appointmentState.services[0]
      );

      for (let i = 1; i < this.appointmentState.services.length; i++) {
        wIntersection = this.intersect(
          wIntersection,
          this.workersIdsPerService.get(this.appointmentState.services[i])
        );
      }

      // Restrict the resource-step list to (subset ∩ service-capable).
      if (this.isWorkerSubsetActive() && wIntersection?.length) {
        wIntersection = wIntersection.filter(id => this.selectedWorkerIds.includes(id));
      }

      // Set current available workers with whole objects
      if (wIntersection?.length) {
        wIntersection.forEach((workerId) => {
          const tempWorker: UserDao = this.allWorkerObjects.get(workerId);
          if (tempWorker != null && tempWorker?.is_directly_bookable) {
            if (this.partner.is_round_robin_feature_enabled === 1) {
              if (tempWorker?.is_round_robin_enabled === 1) {
                this.workersAvailable.push(tempWorker);
              }
            } else {
              this.workersAvailable.push(this.allWorkerObjects.get(workerId));
            }
          }

          if (this.appointmentState.worker === workerId) {
            this.keepWorkerId++;
          }
        });

        if (this.keepWorkerId === 0 && this.appointmentState.worker !== 0) {
          this.appointmentState.worker = null;
        }
      }

      if (this.workersAvailable?.length && Number(this.partner.show_worker_selection_on_date_step) === 1) {
        // Creating dummy object for anyone option
        const anyoneOption = new UserDao();
        anyoneOption.id = 0;

        // Manually preparing worker select options with anyone option on top
        this.workersAvailableWithAnyoneOption = [
          anyoneOption,
          ...this.workersAvailable
        ]
      } else {
        this.workersAvailableWithAnyoneOption = this.workersAvailable;
      }

      this.customEventService.redefineDefaultWorkerIdEvent.emit(this.workersAvailable)
    }
  }

  // To change state of previous button in calendar
  private updateCalendarPrevState(viewDate: Date): void {
    this.disablePrev = viewDate.getMonth() <= this.now.getMonth() && viewDate.getFullYear() <= this.now.getFullYear();
  }

  private updateAppointmentCustomFields() {
    let appointmentServices: number[] = [];
    this.cart.forEach(service => appointmentServices = appointmentServices.concat(service.servicesIds));
    appointmentServices = [...new Set(appointmentServices)];
    if (appointmentServices.length > 0) {
      this.isCustomFieldsLoaded = false;
      this.tempArray = [];

      this.formService
        .getAppointmentCustomFields(appointmentServices)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: appointmentCustomFields => {
            !appointmentCustomFields && (appointmentCustomFields = []);
            this.tempArray = this.prefillCustomFields(appointmentCustomFields, false);
            this.addonsCustomFields = this.tempArray.filter(customField => customField.is_addon);
            this.appointmentCustomFields = this.tempArray.filter(customField => !customField.is_addon);
            this.isCustomFieldsLoaded = true;
          },
          error: (err: HttpErrorResponse) => {
            LoggerService.error(err);
            this.isCustomFieldsLoaded = true;
          }
        });
    }
  }

  private prefillCustomFields(customFields: CustomFieldsDao[], checkForSupportedService: boolean): CustomFieldsDao[] {
    // Translate any identifier-keyed prefill entries to their numeric custom-field id
    // once, before the id-keyed prefill loop below reads selectedJsonCustomFields.
    this.selectedJsonCustomFields = this.helperService.resolveCustomFieldIdentifierKeys(this.selectedJsonCustomFields, customFields);

    const trimmedArray = Array<CustomFieldsDao>();
    const values = Array<number>();

    for (let y = 0, len = Object.keys(customFields).length; y < len; y++) {
      const value = customFields[y]['id'];
      if (values.indexOf(value) === -1 && !customFields[y]['parent_custom_field_id']) {
        trimmedArray.push(customFields[y]);

        if ([
          this.bookingCustomFieldTypes.SELECT,
          this.bookingCustomFieldTypes.CARD_SELECT,
          this.bookingCustomFieldTypes.IMAGE_SELECT
        ].includes(customFields[y].type)) {
          if (!this.customFieldValues[customFields[y].id]) {
            if (customFields[y].is_multiple_select === 1) {
              const temp = this.selectedJsonCustomFields && this.selectedJsonCustomFields[customFields[y].id]
                ? this.selectedJsonCustomFields[customFields[y].id]
                : undefined;
              // temp is a comma-string on the querystring path, but the webcomponent's
              // selected-custom-fields JSON can deliver an array/number for a multi-select —
              // handle all three so .split() never throws "split is not a function".
              const finalValue = temp
                ? (Array.isArray(temp)
                  ? temp.map((value: any) => Number(value))
                  : String(temp).split(',').map((value: string) => Number(value)))
                : [];
              this.customFieldValues[customFields[y].id] = {
                value: finalValue,
                type: customFields[y].type
              };
            } else {
              if (this.selectedJsonCustomFields && this.selectedJsonCustomFields[customFields[y].id]) {
                this.customFieldValues[customFields[y].id] = {
                  value: Number(this.selectedJsonCustomFields[customFields[y].id]),
                  type: customFields[y].type,
                };
              } else if (
                this.customFieldValues[customFields[y].id]
              ) {
                // Do nothing
              } else {
                this.customFieldValues[customFields[y].id] = {
                  value: null,
                  type: customFields[y].type,
                };
              }
            }

            // When checkForSupportedService is true, means we need to check for jumping of service step
            // and prepare mappedServices array based on selected option
            // Limitation: in case multiple prefilled question has supported service, then only last question
            // will be considered for supported service
            if (
              checkForSupportedService &&
              this.customFieldValues[customFields[y].id]?.value?.length
            ) {
              for (let selectedOption of this.customFieldValues[customFields[y].id]?.value) {
                const option = customFields[y].custom_field_options.find(option => option.id === selectedOption);
                if (option?.supported_appointment_service_ids) {
                  const selectedOptionSupportedServiceIds = JSON.parse(option.supported_appointment_service_ids) as string[];
                  const mappedServiceIdsObj: MappedAppointmentServicesDao = {};
                  mappedServiceIdsObj[customFields[y].id] = {
                    serviceIds: selectedOptionSupportedServiceIds.map(Number),
                    is_multiple_select: !!Number(customFields[y].is_multiple_select)
                  };
                  this.appointmentService.mappedServiceIds = mappedServiceIdsObj;
                }
              }
            }
          }
        } else if (customFields[y].type === this.bookingCustomFieldTypes.NUMBER_SELECT) {
          const optionIds = customFields[y].custom_field_options.map(option => option.id);
          const optionValues = customFields[y].custom_field_options.map(option => {
            option.option_value = option.number_default;
            return {
              custom_field_option_id: option.id,
              custom_field_option_value: option.number_default,
            };
          });

          this.customFieldValues[customFields[y].id] = {
            value: optionIds,
            option_values: optionValues,
            type: customFields[y].type,
          };
        } else if (customFields[y].type === this.bookingCustomFieldTypes.FILE) {
          this.customFieldValues[customFields[y].id] = {
            type: this.bookingCustomFieldTypes.FILE,
            file_ids: this.customFieldValues[customFields[y].id]?.file_ids?.length > 0
              ? this.customFieldValues[customFields[y].id]?.file_ids
              : [],
          };
        } else {
          if ([
            this.bookingCustomFieldTypes.TEXT,
            this.bookingCustomFieldTypes.TEXTAREA,
            this.bookingCustomFieldTypes.RADIO,
            this.bookingCustomFieldTypes.DATE
          ].includes(customFields[y].type)) {
            if (this.selectedJsonCustomFields && this.selectedJsonCustomFields[customFields[y].id]) {
              this.customFieldValues[customFields[y].id] = this.selectedJsonCustomFields[customFields[y].id];
            } else {
              this.customFieldValues[customFields[y].id] = this.customFieldValues[customFields[y].id]
                ? this.customFieldValues[customFields[y].id]
                : undefined;
            }
          } else if (customFields[y].type === this.bookingCustomFieldTypes.CHECKBOX) {
            if (this.selectedJsonCustomFields && this.selectedJsonCustomFields[customFields[y].id]) {
              this.customFieldValues[customFields[y].id] = ["true", "1", true, 1].includes(this.selectedJsonCustomFields[customFields[y].id]) ? true : false;
            } else {
              this.customFieldValues[customFields[y].id] = this.customFieldValues[customFields[y].id]
                ? ["true", "1", true, 1].includes(this.customFieldValues[customFields[y].id]) ? true : false
                : false;
            }
          }
        }

        values.push(value);
      } else {
        LoggerService.warn(`CALENSO_WIDGET: Custom field ${customFields[y]['id']} is ignored!`);
      }
    }

    // sorting of custom fields by position
    trimmedArray.sort(function (a, b) {
      return a.position - b.position;
    });

    return trimmedArray;
  }

  getCustomerCustomFieldSelectValue(): void {
    this.appointmentCustomFields
      .filter(customField => customField.is_hidden === 0)
      .forEach(customField => {
        this.getCustomerCustomFieldDependentValues(customField);
        if (customField.customFieldDependencies?.length) {
          customField.customFieldDependencies.forEach(dependentCustomField => {
            this.getCustomerCustomFieldDependentValues(dependentCustomField);
          });
        }
      });

    this.showSummaryDetails = true;
  }

  getCustomerCustomFieldDependentValues(customField: CustomFieldsDao): void {
    const customFieldsValue = { ...this.customFieldValues, ...this.qualificationQuestionsValues };

    let value = customFieldsValue[customField.id]?.value || customFieldsValue[customField.id];
    if ([this.bookingCustomFieldTypes.SELECT, this.bookingCustomFieldTypes.RADIO, this.bookingCustomFieldTypes.IMAGE_SELECT,
    this.bookingCustomFieldTypes.CARD_SELECT].includes(customField.type)) {
      value = Array.isArray(value) ? value : [value];
      const options = customField.custom_field_options.filter(option => value?.includes(option.id));
      options && (this.summaryDetails.customFieldValues[customField.id] = { options });
    } else if (customField.type === this.bookingCustomFieldTypes.NUMBER_SELECT) {
      const options = [];
      customField.custom_field_options.forEach(option => {
        const value = customFieldsValue[customField.id].option_values?.find((value: { custom_field_option_id: number; custom_field_option_value: number; }) => value.custom_field_option_id === option.id);
        options.push({ option, value: (value?.custom_field_option_value || 0) });
      });
      this.summaryDetails.customFieldValues[customField.id] = { options };
    } else if (![this.bookingCustomFieldTypes.FILE, this.bookingCustomFieldTypes.INFORMATION].includes(customField.type)) {
      this.summaryDetails.customFieldValues[customField.id] = { value };
    }
  }

  /** Helpers */

  // Helper function for find available workers
  private intersect(a, b) {
    let t;
    if (b.length > a.length) {
      (t = b), (b = a), (a = t); // indexOf to loop over shorter
    }
    return a.filter(function (e) {
      return b.indexOf(e) > -1;
    });
  }

  // Init form state and cart based on local storage values
  private initFormState(): void {
    this.setInitStateLSName();
    this.setInitCartLSName();
    this.setInitUserLSName();
    this.setInitCustomFieldsLSName();
    this.setInitInternalComment();
  }

  private setInitInternalComment(): void {
    // prefill internal_comment if present
    if (this.internalComment) {
      Object.assign(this.userState, {
        internal_comment: this.internalComment
      });
    }
  }

  private setInitCartLSName(): void {
    this.localStorageService.getItem(this.CART_LS_NAME, (savedCartState) => {
      if (savedCartState) {
        this.cart = savedCartState;
      }
    });
  }

  private setInitUserLSName(): void {
    this.localStorageService.getItem(this.USER_LS_NAME, (savedUserState) => {
      if (savedUserState) {
        this.userState = savedUserState;
      }
    });
  }

  private setInitCustomFieldsLSName(): void {
    this.localStorageService.getItem(this.CUSTOMFIELDS_LS_NAME, (savedCustomFieldsState) => {
      if (savedCustomFieldsState) {
        // Skip file-type answers — uploaded file tokens are consumed by the
        // previous booking and cannot be reused for a subsequent one.
        const filtered = {};
        Object.keys(savedCustomFieldsState).forEach((key) => {
          if (savedCustomFieldsState[key]?.type !== this.bookingCustomFieldTypes.FILE) {
            filtered[key] = savedCustomFieldsState[key];
          }
        });
        this.customFieldValues = filtered;
      }
    });
  }

  private scrollToAppointmentComponent(): void {
    if (this.widgetConf?.scroll_to_element_feature_is_enabled === 1) {
      const element = getDomRoot(this.elementRef.nativeElement).getElementById('appointment-component');
      element?.scrollIntoView();
    }
  }

  private resetDataBeforeLoadingSummaryPage() {
    // Only reset feature flags — they're re-populated by verifyOnlinePaymentStatus().
    // Do NOT reset coupon, payment data, or cart-derived state — navigating back to
    // summary should preserve what the customer already applied. Resetting here
    // caused coupon loss when switching payment types and addon re-add after PayPal
    // had an order open (JB-914 follow-ups).
    this.isStripeEnabled = false;
    this.isOnlinePaymentMandatory = false;
    this.isBexioEnabled = false;
    this.isExternalInvoiceEnabled = false;
    this.isStoreEnabled = false;
    this.isLexOfficePaymentTypeEnabled = false;
    this.isPaypalEnabled = false;
    this.isSaferpayEnabled = false;
    // Reset with its siblings: a stale true here offers Adyen on the next summary before the
    // per-booking gate answers, and every other provider flag is already cleared on this path.
    this.isAdyenEnabled = false;
  }

  payUsingSaferpay(): void {
    if (this.appointmentForm.valid && this.formService.imageUploaded === true) {
      this.showFullscreenOverlay = true;
      this.paymentService.initiateSaferpaySubject.next(true);
    } else {
      this.markFormGroupTouched(this.appointmentForm);
      this.isPaymentBookButtonValidated();
    }
  }

  closeSaferpayOverlay(): void {
    this.showFullscreenOverlay = false;
    this.onResetSaferpayEvent('');
    this.paymentService.handleSaferpayBackgroundTriggerManually.next(true);
  }

  payUsingStripe(): void {
    if (this.stripePaymentMethodId) {
      this.book();
      return;
    }
    if (this.appointmentForm.valid && this.formService.imageUploaded === true) {
      this.disableBookingButton = true;
      this.bookButtonLoader = true;
      this.paymentService.initiateStripeSubject.next(true);
    } else {
      this.markFormGroupTouched(this.appointmentForm);
      this.isPaymentBookButtonValidated();
    }
  }

  prepareAnalyticsPayload(): AppointmentAnalyticsDao {
    const payload = new AppointmentAnalyticsDao();
    const store: { [key: string]: string | number } = {};
    const worker: { [key: string]: string | number } = {};
    const servicesName = [];

    // get store details is present
    if (this.appointmentState?.store && this.stores?.length > 0) {
      const foundStore = this.stores.find(_store => _store.id === this.appointmentState.store);
      store.id = this.appointmentState.store;
      store.name = foundStore?.name || undefined;
    }

    // get worker details is present
    if (this.appointmentState?.worker && this.workersAvailable?.length > 0) {
      const foundWorker = this.workersAvailable.find(_worker => _worker.id === this.appointmentState.worker);
      worker.id = this.appointmentState.worker;
      worker.email = (foundWorker?.email || undefined);
      worker.name = (foundWorker?.resource_name || undefined);
    }

    // prepare service name string
    if (this.appointmentState?.services && this.appointmentServicesAvailable?.length > 0) {
      this.appointmentServicesAvailable.forEach(service => {
        if (this.appointmentState.services.includes(Number(service.id))) {
          servicesName.push(service.name);
        }
      });
    }

    // prepare final payload object
    if (this.appointmentState?.services) {
      payload.appointment_service_id = this.appointmentState.services.join(',');
    }

    if (servicesName.length) {
      payload.appointment_service_name = servicesName.join(',');
    }

    if (worker?.id) {
      payload.worker_id = worker.id;
      payload.resource_name = worker?.name;
      payload.worker_email = worker?.email;
    }

    if (store?.id) {
      payload.store_id = store.id;
      payload.store_name = store?.name;
    }

    return payload;
  }

  submitQualificationQuestions(isSubmitted: boolean): void {
    if (isSubmitted) {
      if (this.appointmentService.mappedServiceIds.length) {
        if (this.appointmentService.mappedServiceIds.length === 1) {
          this.appointmentState.services = [this.appointmentService.mappedServiceIds[0]];
        }

        const storeParams: {
          appointment_service_ids: number[],
          worker_id?: number,
          worker_ids?: number[],
          category_ids?: number[],
          selected_store_id?: number
        } = {
          appointment_service_ids: this.appointmentService.mappedServiceIds,
          // Same point-of-use coercion as the other two lookup sites. A truthy test would drop the
          // "anyone" sentinel 0, and a bare Number() would turn a non-numeric attribute into NaN,
          // which serialises to null.
          worker_id: this.isWorkerSubsetActive() ? undefined : this.toOptionalNumber(this.selectedWorkerId),
          // Keeps a deeplink-only store named by the link in the re-fetched list.
          selected_store_id: this.toOptionalNumber(this.selectedStoreId),
        };

        if (this.isWorkerSubsetActive()) {
          // Subset mode returns the union of the subset workers' stores.
          storeParams.worker_ids = this.selectedWorkerIds;
        }

        if (this.selectedAppointmentServiceCategoryIds?.length) {
          storeParams.category_ids = this.selectedAppointmentServiceCategoryIds.map(id => Number(id));
        }

        // Answering the questions re-runs the lookup, so clear any verdict from the previous one.
        // Without this the flag latches: a first empty result would keep the wizard hidden even
        // when the second lookup returns bookable stores.
        this.resetBookingAvailabilityState();

        this.formService.getStores(storeParams)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: stores => {
              if (stores?.length) {
                if (!this.globals.isInternal) {
                  this.stores = stores.filter(store => store.has_only_internal_appointment_service === 0);
                } else {
                  this.stores = stores;
                }
              } else {
                this.stores = [];
                if (this.isWorkerScopedLookup(storeParams)) {
                  this.bookingUnavailable.set(true);
                }
              }

              this.afterAppointmentServiceToggled();
              this.storesResolved.set(true);
              this.setupStoreSelection(this.stores);

              // In case single service is operated at more than single store do not jump to worker step instead
              // let user to stay on first step and emit event to reset the appointment category wise list based
              // on selected answers mapped services
              if (this.stores?.length > 1) {
                this.appointmentService.resetAppointmentCategoryWiseListEvent.emit();
              } else {
                // Preselecting worker
                if (
                  (this.selectedWorkerId || Number(this.selectedWorkerId) === 0) &&
                  this.selectedAppointmentServiceIds?.length > 0
                ) {
                  LoggerService.log('[Debug] WorkerID and ServiceID both are present so pre-selecting a worker');
                  this.preselectWorker();
                } else {
                  // Auto-skip to the Worker step ONLY when qualification narrowed to exactly one
                  // mapped service AND widget_jumps_to_resources_step_when_single_service is enabled.
                  // For multi-service results, stay on the services step — processLoadedServices
                  // (triggered by setupStoreSelection above) will emit resetAppointmentCategoryWiseListEvent
                  // once services load, which filters the list to the qualification-mapped services.
                  if (
                    this.appointmentService.mappedServiceIds.length === 1 &&
                    this.partner.widget_jumps_to_resources_step_when_single_service === 1
                  ) {
                    this.navigateTo(this.appointmentConstant.WORKER, false);
                  }
                }
              }

              this.hasQualificationQuestionsAnswered = true;
            },
            error: (err: HttpErrorResponse) => {
              // Only on THIS path: the visitor has already answered, and the overlay covers the
              // widget until the gate flips — so without this the failure message below is built
              // and never shown. Deliberately not inside handleStoresLoadError: that handler is
              // shared with the initial fetchAvailableStores(), which races the qualification
              // lookup on load, and flipping the gate there would dismiss mandatory questions the
              // visitor never saw.
              this.hasQualificationQuestionsAnswered = true;
              this.handleStoresLoadError(err, storeParams);
            }
          });
      } else {
        this.hasQualificationQuestionsAnswered = true;
      }
    } else {
      this.hasQualificationQuestionsAnswered = true;
    }
  }

  showWorkersListOnDateStepFn(): void {
    if (Number(this.partner.show_worker_selection_on_date_step) === 1) {
      this.showWorkersListOnDateStep = !this.showWorkersListOnDateStep;
    }
  }

  customWorkerSearchFn(query: string, worker: WorkerDao): boolean {
    const subTitle = Number(worker?.is_resource) === 1 ? worker?.description : worker?.job_title;
    const searchData = `${worker?.resource_name} (${subTitle})`;
    return searchData?.toLowerCase().includes(query?.toLowerCase());
  }

  protected getHideMeetingTypesStepValue(value: boolean): void {
    this.hideMeetingTypesStep = value;
  }

  private getAllCalendarHighlights(): void {
    this.calendarHighlightService.getAllHighlights(
      moment().add(this.partner.future_booking_threshold_appointments, 'days').format('YYYY-MM-DD')
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: highlight => this.calendarHighlightData = highlight || [],
        error: (error: HttpErrorResponse) => LoggerService.error(error)
      });
  }

  protected getExceptionalWorkers(exceptionWorkersDetails: {
    isExceptionEnabled: boolean,
    exceptionalWorkers: string[]
  }): void {
    if (exceptionWorkersDetails.isExceptionEnabled) {
      this.exceptionWorkers = exceptionWorkersDetails.exceptionalWorkers;
    } else {
      this.exceptionWorkers = [];
    }
  }

  protected checkForWidgetCalendarNotice(): void {
    if (!Number(this.partner.show_widget_calendar_notice) || !this.calendarHighlightData?.length) {
      return;
    }

    const viewMonth = moment(this.viewDate).month(); // Extract the month (0-based index)
    const servicesSet = new Set(this.appointmentState.services);
    const workerId = this.appointmentState.worker;

    // Step 1: Filter based on viewMonth, overwrite_calendar_hint_banner, and worker/service match
    let filteredList = this.calendarHighlightData.filter(item => {
      const hasOverwriteBannerGlobal = item.overwrite_calendar_hint_banner_globally;
      const hasOverwriteBanner = item.overwrite_calendar_hint_banner;

      const startMonth = moment(item.start).month();
      const endMonth = moment(item.end).month();

      // Skip start and end date comparison if overwrite globally is enabled
      const isWithinMonthRange = hasOverwriteBannerGlobal || (viewMonth >= startMonth && viewMonth <= endMonth);

      const matchesWorker = item.worker_id ? item.worker_id === workerId : true;
      const matchesService = item.appointment_service_id ? servicesSet.has(item.appointment_service_id) : true;

      return isWithinMonthRange && hasOverwriteBanner && matchesWorker && matchesService;
    });

    // Step 2: Prioritize Worker + Appointment Service -> Partner
    const hasWorkerOrService = filteredList.some(item => item.worker_id !== null || item.appointment_service_id !== null);

    if (hasWorkerOrService) {
      filteredList = filteredList.filter(item => item.worker_id !== null || item.appointment_service_id !== null);
    }

    // If no Worker or Appointment Service exists, keep Partner objects by default.
    this.showWidgetCalendarOverwriteNotice = filteredList;
  }

  protected redirectToExternalUrl(): void {
    this.helperService.redirectToUrl(this.partner.successful_booking_redirect_url);
  }

  protected toggleTroubleshootingMode(): void {
    this.troubleshootingModeEnabled = !this.troubleshootingModeEnabled;
    this.customEventService.toggleTroubleshootEvent.next(this.troubleshootingModeEnabled);

    this.calendarLoaded = false;

    this.resetCalendarData();
    this.customEventService.refreshCalendarEvent.emit();
  }

  /**
   * Randomizes workers with the same start and end times while maintaining chronological order
   * @param appointments Array of appointments to process
   * @returns Array with randomized workers for same time slots
   */
  private randomizeWorkersWithSameTimeSlots(appointments: AppointmentsSlotsDao[]): AppointmentsSlotsDao[] {
    const groups = new Map<string, AppointmentsSlotsDao[]>();

    // Group appointments by start and end times
    appointments.forEach(appointment => {
      const key = `${appointment.short_start}-${appointment.end}`;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key)!.push(appointment);
    });

    // Randomize workers within each group and flatten the result
    const result: AppointmentsSlotsDao[] = [];
    const sortedKeys = Array.from(groups.keys()).sort((a, b) => {
      const aStart = a.split('-')[0];
      const bStart = b.split('-')[0];
      return Number(aStart) - Number(bStart);
    });

    sortedKeys.forEach(key => {
      const group = groups.get(key)!;
      // Shuffle the group to randomize workers with same start/end times
      const shuffledGroup = this.helperService.shuffleArray([...group]);
      result.push(...shuffledGroup);
    });
    return result;
  }

  protected onTimezoneChange(timezone: string): void {
    this.userState.timezone = timezone;
    this.cart.forEach(cartItem => this.removeFromCart(cartItem.cartItemId));
    this.setupDates();
  }
}
